import React, { Component, memo } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import _, { get, isObject, pick, omit, isEmpty } from 'lodash'
import Styled from 'styled-components'
import { Anchor, Col, Icon, InputNumber, Row, Select, Tooltip } from 'antd'
import {
  blueBorder,
  green,
  lightGrey9,
  red,
  themeColor,
} from '@edulastic/colors'

import {
  CheckboxLabel,
  EduSwitchStyled,
  FieldLabel,
  MainContentWrapper,
  notification,
  RadioBtn,
  SelectInputStyled,
  TextInputStyled,
  withWindowSizes,
  EduButton,
  EduIf,
  FlexContainer,
} from '@edulastic/common'
import {
  roleuser,
  subscriptions,
  test as testConstants,
  tutorials,
} from '@edulastic/constants'
import { multipartEvaluationTypes } from '@edulastic/constants/const/evaluationType'
import {
  IconInfo,
  IconTrash,
  IconWarnCircle,
  IconWarnTriangle,
} from '@edulastic/icons'
import { withNamespaces } from '@edulastic/localization'
import EduJoyride from '@edulastic/common/src/components/Joyride'

import {
  TEST_CONTENT_VISIBILITY,
  testContentVisibility as contentVisiblityOptions,
  testCategoryTypes,
} from '@edulastic/constants/const/test'
import { TEST_TYPE_SURVEY } from '@edulastic/constants/const/testTypes'
import { segmentApi } from '@edulastic/api'
import { sanitizeUrl } from '@edulastic/common/src/utils/html'
import { LANGUAGE_EN } from '@edulastic/constants/const/languages'
import { ACTIONS, EVENTS, LIFECYCLE } from 'react-joyride'
import * as Sentry from '@sentry/browser'
import { isFeatureAccessible } from '../../../../../../features/components/FeaturesSwitch'
import {
  getUserFeatures,
  getUserRole,
  getUserId,
  getUserPermissions,
} from '../../../../../../student/Login/ducks'
import {
  defaultTestTypeProfilesSelector,
  getDisableAnswerOnPaperSelector,
  getReleaseScorePremiumSelector,
  getTestEntitySelector,
  resetUpdatedStateAction,
  setTestDataAction,
  saveTestSettingsAction,
  getTestSettingsListSelector,
  getTestDefaultSettingsSelector,
  deleteTestSettingRequestAction,
  updateTestSettingRequestAction,
  togglePenaltyOnUsingHintsAction,
  hasSectionsSelector,
  canSchoolAdminUseDistrictCommonSelector,
  isSurveyTestSelector,
  isDynamicTestSelector,
  isNormalSectionsTestSelector,
  canTeacherAuthorCommonTestsSelector,
} from '../../../../ducks'
import Breadcrumb from '../../../../../src/components/Breadcrumb'

import { setMaxAttemptsAction, setSafeBrowserPassword } from '../../ducks'
import {
  allowedToSelectMultiLanguageInTest,
  isEtsDistrictSelector,
  allowReferenceMaterialSelector,
  getIsAiEvaulationDistrictSelector,
  getUserOrgId,
  isUserDistrictSuperAdminSelector,
  getTestTypesFormatedConstant,
  getUserTestTypes,
  getCurrentSchoolState,
} from '../../../../../src/selectors/user'
import {
  Block,
  BlueText,
  Body,
  Container,
  Description,
  Label,
  MessageSpan,
  NavigationMenu,
  RadioWrapper,
  SettingsCategoryBlock,
  StyledAnchor,
  StyledRadioGroup,
  Title,
  StyledTestSettingFeatureBannerContainer,
  StyledRadioGroupItemRow,
} from './styled'
import PerformanceBand from './PerformanceBand'
import StandardProficiencyTable from './StandardProficiencyTable'
import Instruction from './InstructionBlock/InstructionBlock'
import DollarPremiumSymbol from '../../../../../AssignTest/components/Container/DollarPremiumSymbol'
import {
  SettingContainer,
  DeleteIconContainer,
  SavedSettingsContainer,
} from '../../../../../AssignTest/components/Container/styled'
import {
  CheckBoxWrapper,
  StyledRow,
} from '../../../../../AssignTest/components/SimpleOptions/styled'
import KeypadDropdown from './KeypadDropdown'
import ReferenceMaterial from './ReferenceMaterial'
import { getAssignmentsSelector } from '../../../Assign/ducks'
import { ConfirmationModal } from '../../../../../src/components/common/ConfirmationModal'
import {
  skinTypesOrder,
  showRubricToStudentsSetting,
  showAutoEssayEvaluationSetting,
  getSettingsToSaveOnTestType,
} from '../../../../utils'
import SaveSettingsModal from '../../../../../AssignTest/components/Container/SaveSettingsModal'
import DeleteTestSettingsModal from '../../../../../AssignTest/components/Container/DeleteSettingsConfirmationModal'
import UpdateTestSettingsModal from '../../../../../AssignTest/components/Container/UpdateTestSettingModal'
import { multiFind } from '../../../../../../common/utils/main'
import {
  getAvailableTestTypesForUser,
  getProfileKey,
  includeCommonOnTestType,
} from '../../../../../../common/utils/testTypeUtils'
import HintsToStudents from './HintsToStudents'
import ShowSectionSettings from './SectionSettings'
import CalculatorSettings, {
  CalculatorSettingsDescription,
} from '../../../../../Shared/Components/CalculatorSettings'
import { safeModeI18nTranslation } from '../../../../../authUtils'
import ContentVisibilityOptions from '../Common/ContentVisibilityOptions'
import { isPearDomain } from '../../../../../../../utils/pear'
import {
  edulasticText,
  onEnterKeyPressHandler,
  pearAssessmentText,
  setSelectSearchAriaLabel,
} from '../../../../../../common/utils/helpers'
import { BetaTag2 } from '../../../../../../common/components/BetaTag'

import {
  getTestSettings,
  receiveTestSettingAction,
} from '../../../../../TestSetting/ducks'

import { stackedTranslationBoolToStringMap } from '../../../../../../assessment/components/Common/StackedTranslator/constants'
import HelperToolTip from '../../../../../../assessment/components/EvaluationSettings/components/HelperToolTip'
import AccommodationDescription from './AccommodationDescription'
import AdvancedTestTypeSelection from './AdvancedTestTypeSelection'
import { getSubscriptionSelector } from '../../../../../Subscription/ducks'
import Accommodations from './Accommodations'
import { getAccommodationsSettingOptions } from '../../../../../TestSetting/utils'
import { FeatureBannerPlaceholder } from '../../../../../FeatureBanner'
import DynamicPasswordScopeInput, {
  dynamicPasswordScopeInputFormat,
} from '../../../../../AssignTest/components/Container/DynamicPasswordScopeInput'
import { getAllTestTypesWithBaseType } from '../../../../../src/utils/testTypes'
import {
  changeTestDataInPreferredLanguage,
  changeTestDataToPreferredLanguage,
} from '../../../../../../assessment/utils/test'
import {
  setViewedTutorialsAction,
  viewedTutorialsSelector,
} from '../../../../../../tutorials/tutorialReducer'
import {
  getTestInstructionsMultilanguageTutorialStepStyles,
  TEST_INSTRUCTIONS_MULTILANGUAGE_TUTORIAL_STEPS,
} from '../../../../../src/constants/others'

const {
  settingCategories: defaultSettingCategories,
  settingCategoriesFeatureMap,
  completionTypes,
  evalTypes,
  evalTypeLabels,
  accessibilities,
  releaseGradeTypes,
  releaseGradeLabels,
  releaseGradeKeys,
  nonPremiumReleaseGradeKeys,
  passwordPolicy: passwordPolicyValues,
  passwordPolicyOptions,
  playerSkinTypes,
  playerSkinValues,
  settingsList,
  TEST_SETTINGS_SAVE_LIMIT,
  accessibilitySettings,
  accommodationsSettings,
} = testConstants

const { magnifier, scratchPad, skipAlert, uploadWork } = accessibilitySettings
const { immersiveReader, speechToText } = accommodationsSettings

const { Option } = Select

const {
  ALL_OR_NOTHING,
  PARTIAL_CREDIT,
  ITEM_LEVEL_EVALUATION,
  PARTIAL_CREDIT_IGNORE_INCORRECT,
} = evalTypeLabels

class Setting extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showPassword: false,
      inputBlur: false,
      _releaseGradeKeys: nonPremiumReleaseGradeKeys,
      isTestBehaviorGroupExpanded: true,
      isAntiCheatingGroupExpanded: true,
      isMiscellaneousGroupExpanded: true,
      isSectionsGroupExpanded: true,
      warningKeypadSelection: false,
      warningFreezeSetting: false,
      selectedKeypad: null,
      showSaveSettingsModal: false,
      showDeleteSettingModal: false,
      showUpdateSettingModal: false,
      settingDetails: null,
      isStudentToolsGroupExpanded: true,
      isAccommodationsExpanded: true,
      lastSettingValue: {},
      testInstructionsJoyrideRun: true,
      testInstructionsJoyrideStepIndex: 0,
    }

    this.containerRef = React.createRef()
  }

  static getDerivedStateFromProps(nextProps) {
    const { features, entity } = nextProps
    const { grades, subjects, isDocBased } = entity
    if (
      features?.assessmentSuperPowersReleaseScorePremium ||
      (grades &&
        subjects &&
        isFeatureAccessible({
          features,
          inputFeatures: 'assessmentSuperPowersReleaseScorePremium',
          gradeSubject: { grades, subjects },
        }))
    ) {
      return {
        _releaseGradeKeys: releaseGradeKeys,
      }
    }
    if (features.canUseImmersiveReader && !isDocBased) {
      this.updateTestData(immersiveReader.key)(false)
    }
    if (features.speechToText) {
      this.updateTestData(speechToText.key)(false)
    }
    return {
      _releaseGradeKeys: nonPremiumReleaseGradeKeys,
    }
  }

  componentDidMount = () => {
    const {
      entity,
      resetUpdatedState,
      loadDistrictTestSetting,
      districtId,
      isSurveyTest,
    } = this.props
    // Load district settings
    loadDistrictTestSetting({ orgType: 'district', orgId: districtId })
    if (isSurveyTest) {
      this.updateTestData('scoringType')(ITEM_LEVEL_EVALUATION)
    } else if (entity?.scoringType === PARTIAL_CREDIT && !entity?.penalty) {
      this.updateTestData('scoringType')(PARTIAL_CREDIT_IGNORE_INCORRECT)
    }
    if (entity?.safeBrowser) {
      this.updateTestData('safeBrowser')(true)
    }
    // resetting updated state on mount
    resetUpdatedState()
  }

  scrollToTestInstructionSettings = () => {
    try {
      const testInstructionsSectionElement = document.getElementById(
        'add-instruction'
      )
      testInstructionsSectionElement?.scrollIntoView({
        behavior: 'instant',
        block: 'center',
      })
    } catch (err) {
      Sentry.captureException(err)
    }
  }

  setTestInstructionsJoyrideStepStyles = () => {
    try {
      const floater = document.querySelector('.__floater.__floater__open')

      if (floater) {
        Object.assign(floater.style, { opacity: 0 })
        setTimeout(() => {
          const { testInstructionsJoyrideStepIndex } = this.state
          const { entity } = this.props
          const hasInstruction = !!entity?.hasInstruction

          const joyrideStepStyles = getTestInstructionsMultilanguageTutorialStepStyles(
            testInstructionsJoyrideStepIndex,
            hasInstruction,
            floater
          )
          Object.assign(floater.style, joyrideStepStyles, { opacity: 1 })
        }, 200)
      }
    } catch (err) {
      Sentry.captureException(err)
    }
  }

  handleShowPassword = () => {
    this.setState((state) => ({ showPassword: !state.showPassword }))
  }

  updateAttempt = (e) => {
    const { setMaxAttempts } = this.props
    let { value = 0 } = e.target
    if (value < 0) value = 0
    setMaxAttempts(parseInt(value, 10))
  }

  setPassword = (e) => {
    const _sebPassword = e.target.value
    const { setSafePassword, t: i18translate } = this.props
    setSafePassword(_sebPassword)
    if (_sebPassword.split(' ').length > 1) {
      return this.setState({
        sebPasswordErrorMessage: i18translate(
          'passwordValidationMessage.space'
        ),
      })
    }

    return this.setState({
      sebPasswordErrorMessage: '',
    })
  }

  keypadSelection = (value) => {
    if (!value) {
      return
    }
    if (value.type === 'item-level') {
      this.updateTestData('keypad')(value)
    } else {
      this.setState({ selectedKeypad: value, warningKeypadSelection: true })
    }
  }

  toggleFreezeSettings = (value) => {
    if (!value) {
      this.updateTestData('freezeSettings')(!value)
    } else {
      this.setState({ warningFreezeSetting: true })
    }
  }

  confirmKeypadSelection = (confirm = false) => {
    const { selectedKeypad } = this.state
    if (confirm === true && selectedKeypad && selectedKeypad.type) {
      this.updateTestData('keypad')(selectedKeypad)
    }
    this.setState({ warningKeypadSelection: false })
  }

  confirmFreezeSettingsDisable = (confirm = false) => {
    if (confirm === true) {
      this.updateTestData('freezeSettings')(false)
    }
    this.setState({ warningFreezeSetting: false })
  }

  handleApplyEBSR = (event) => {
    const {
      target: { checked },
    } = event
    const { setTestData } = this.props
    setTestData({
      applyEBSR: checked,
    })
  }

  updateTestData = (key, language = LANGUAGE_EN) => (value) => {
    const {
      setTestData,
      setMaxAttempts,
      performanceBandsData,
      standardsData,
      defaultTestTypeProfiles,
      isReleaseScorePremium,
      disableAnswerOnPaper,
      allTestTypesInternal,
      userTestTypesInternal,
      entity,
    } = this.props

    const {
      testType,
      penaltyOnUsingHints,
      restrictNavigationOut = null,
      restrictNavigationOutAttemptsThreshold = 0,
    } = entity

    const {
      instruction,
      instructionAcknowledgementText,
      languageFeatures,
    } = changeTestDataToPreferredLanguage(entity, language)

    const extraData = {}
    switch (key) {
      case 'testType': {
        const allTestTypesInternalList = _.flatten(
          Object.values(allTestTypesInternal)
        )
        if (!allTestTypesInternalList.includes(testType)) {
          notification({
            type: 'warn',
            msg:
              'Test type changed. Settings updated to this test type’s defaults.',
          })
        }
        const newBaseTestType = userTestTypesInternal[value]?.baseType || value
        const oldBaseTestType =
          userTestTypesInternal[testType]?.baseType || testType
        const baseTestTypeChanged = oldBaseTestType !== newBaseTestType
        if (baseTestTypeChanged) {
          const testProfileType = getProfileKey(value, allTestTypesInternal)
          const defaultBandId =
            defaultTestTypeProfiles?.performanceBand?.[testProfileType]
          const defaultStandardId =
            defaultTestTypeProfiles?.standardProficiency?.[testProfileType]
          const performanceBand =
            performanceBandsData.find((item) => item._id === defaultBandId) ||
            {}
          const standardGradingScale =
            standardsData.find((item) => item._id === defaultStandardId) || {}
          if (allTestTypesInternal.COMMON.includes(value)) {
            Object.assign(extraData, { allowTeacherRedirect: true })
          }
          if (!allTestTypesInternal.COMMON.includes(value)) {
            Object.assign(extraData, {
              testContentVisibility: contentVisiblityOptions.ALWAYS,
            })
          }
          if (
            allTestTypesInternal.ASSESSMENT.includes(value) ||
            allTestTypesInternal.COMMON.includes(value)
          ) {
            const releaseScore =
              allTestTypesInternal.ASSESSMENT.includes(value) &&
              isReleaseScorePremium
                ? releaseGradeLabels.WITH_RESPONSE
                : releaseGradeLabels.DONT_RELEASE
            setMaxAttempts(1)
            setTestData({
              releaseScore,
              maxAnswerChecks: 0,
              performanceBand: {
                name: performanceBand.name,
                _id: performanceBand._id,
              },
              standardGradingScale: {
                name: standardGradingScale.name,
                _id: standardGradingScale._id,
              },
              freezeSettings: allTestTypesInternal.COMMON.includes(value),
            })
          } else {
            setMaxAttempts(1)
            setTestData({
              releaseScore: releaseGradeLabels.WITH_ANSWERS,
              maxAnswerChecks: 3,
              performanceBand: {
                name: performanceBand.name,
                _id: performanceBand._id,
              },
              standardGradingScale: {
                name: standardGradingScale.name,
                _id: standardGradingScale._id,
              },
              freezeSettings: false,
            })
          }
        }
        break
      }
      case 'scoringType': {
        const penalty = value === evalTypeLabels.PARTIAL_CREDIT
        const dataToSet = {
          penalty,
        }
        if (
          ![
            evalTypeLabels.PARTIAL_CREDIT,
            evalTypeLabels.PARTIAL_CREDIT_IGNORE_INCORRECT,
          ].includes(value)
        ) {
          Object.assign(dataToSet, { applyEBSR: false })
        } else {
          value = evalTypeLabels.PARTIAL_CREDIT
        }
        setTestData(dataToSet)
        break
      }
      case 'safeBrowser':
        /**
         * In case of safe browser ON we are keeping last used values of restrictNavigationOut setting
         * When user switch OFF the safe browser we will use last value of restrictNavigationOut to prefill
         */
        if (!value) {
          setTestData({
            sebPassword: '',
          })
          const { lastSettingValue } = this.state

          setTestData({
            restrictNavigationOut:
              lastSettingValue.restrictNavigationOut || null,
            restrictNavigationOutAttemptsThreshold:
              lastSettingValue.restrictNavigationOutAttemptsThreshold || 0,
          })
        } else {
          this.setState((prevState) => ({
            ...prevState,
            lastSettingValue: {
              restrictNavigationOut,
              restrictNavigationOutAttemptsThreshold,
            },
          }))
          setTestData({
            restrictNavigationOut: null,
            restrictNavigationOutAttemptsThreshold: 0,
          })
        }
        segmentApi.genericEventTrack('KioskModeOnOff', {
          source: 'Test',
        })

        break
      case 'maxAnswerChecks':
        value = parseInt(value, 10)
        if (value < 0) value = 0
        break
      case 'passwordPolicy': {
        if (value === passwordPolicyValues.REQUIRED_PASSWORD_POLICY_DYNAMIC) {
          setTestData({
            passwordExpireIn: 15 * 60,
          })
        } else if (
          value === passwordPolicyValues.REQUIRED_PASSWORD_POLICY_STATIC
        ) {
          setTestData({
            assignmentPassword: '',
          })
        }
        break
      }
      case 'answerOnPaper':
        if (value === true && disableAnswerOnPaper) {
          notification({ messageKey: 'answerOnPaperNotSupportedForThisTest' })
          return
        }
        break
      case 'performanceBand':
        value = pick(
          multiFind(
            performanceBandsData,
            [
              { _id: value._id },
              {
                _id:
                  defaultTestTypeProfiles.performanceBand[
                    getProfileKey(testType, allTestTypesInternal)
                  ],
              },
            ],
            value
          ),
          ['_id', 'name']
        )
        break
      case 'standardGradingScale':
        value = pick(
          multiFind(
            standardsData,
            [
              { _id: value._id },
              {
                _id:
                  defaultTestTypeProfiles.standardProficiency[
                    getProfileKey(testType, allTestTypesInternal)
                  ],
              },
            ],
            value
          ),
          ['_id', 'name']
        )
        break
      case 'showHintsToStudents':
        if (value === false && penaltyOnUsingHints > 0) {
          Object.assign(extraData, { penaltyOnUsingHints: 0 })
        }
        break
      case 'stackedTranslation':
        Object.assign(extraData, {
          stackedTranslation: stackedTranslationBoolToStringMap[value],
        })
        break
      case 'instruction':
        Object.assign(extraData, {
          instructionAcknowledgementText,
          languageFeatures,
        })
        break
      case 'instructionAcknowledgementText':
        Object.assign(extraData, {
          instruction,
          languageFeatures,
        })
        break

      /* showTextToSpeech, showTtsForPassages */
      case 'showTextToSpeech':
        if (value === false) {
          Object.assign(extraData, {
            showTtsForPassages: false,
          })
        }
        break
      default:
        break
    }
    if (language !== LANGUAGE_EN) {
      const updatedEntity = {
        ...entity,
        [key]: value,
        ...extraData,
      }
      const changedTest = changeTestDataInPreferredLanguage(
        language,
        entity,
        updatedEntity
      )
      setTestData(changedTest)
    } else {
      setTestData({
        [key]: value,
        ...extraData,
      })
    }
  }

  updateFeatures = (key) => (e) => {
    const { setTestData } = this.props
    let featVal = key === 'calcTypes' ? e : isObject(e) ? e.target.value : e
    if (typeof featVal === 'undefined') {
      featVal = null
    }
    this.setState({ [key]: featVal })
    setTestData({
      [key]: featVal,
    })
  }

  // Section specific calc types are getting updated in the test state.
  updateSectionCalc = (key, id) => (e) => {
    const { setTestData, entity } = this.props
    let featVal = key === 'calcTypes' ? e : isObject(e) ? e.target.value : e
    if (typeof featVal === 'undefined') {
      featVal = null
    }
    const newItemGroups = entity.itemGroups.map((obj) => {
      if (obj._id === id) {
        return {
          ...obj,
          settings: {
            ...(obj?.settings || {}),
            [key]: featVal,
          },
        }
      }
      return obj
    })
    setTestData({ itemGroups: newItemGroups })
  }

  handleBlur = () => this.setState({ inputBlur: true })

  handleUpdatePasswordExpireIn = (e) => {
    let { value = 1 } = e.target
    value *= 60
    // eslint-disable-next-line no-restricted-globals
    if (value < 60 || isNaN(value)) {
      value = 60
    } else if (value > 999 * 60) {
      value = 999 * 60
    }
    this.updateTestData('passwordExpireIn')(value)
  }

  updateTimedTest = (attr) => (value) => {
    const { totalItems, setTestData } = this.props
    if (value) {
      setTestData({
        [attr]: value,
        pauseAllowed: true,
        allowedTime: totalItems * 60 * 1000,
      })
      return
    }
    setTestData({
      [attr]: value,
    })
  }

  updateExternalData = (key) => (e) => {
    const {
      setTestData,
      entity: { testletConfig = {} },
    } = this.props
    setTestData({
      testletConfig: {
        ...testletConfig,
        [key]: e.target.value,
      },
    })
  }

  togglePanel = (panelType, value) => {
    this.setState({ [panelType]: value })
  }

  get keypadDropdownValue() {
    const { entity: { keypad: testKeypad = {} } = {} } = this.props
    if (!testKeypad.type) return 'item-level-keypad'
    if (testKeypad.type === 'custom') {
      return testKeypad.value?._id
    }
    return testKeypad.value
  }

  handleMouseOver = (e) => {
    e.currentTarget.querySelector('.delete-setting-button').style.display =
      'flex'
  }

  handleMouseOut = (e) => {
    e.currentTarget.querySelector('.delete-setting-button').style.display =
      'none'
  }

  sanitizeSettingsForTest = (initialSettings) => {
    const {
      entity: { itemGroups },
      userRole,
      hasSections,
      canSchoolAdminUseDistrictCommon,
      allTestTypesInternal,
    } = this.props
    const newSettings = omit(initialSettings, [
      'autoRedirect',
      'autoRedirectSettings',
    ])
    const multipartItems = itemGroups
      .map((o) => o.items)
      .flat()
      .filter((o) => o.multipartItem).length
    const [
      commonAssessment,
      schoolCommonAssessment,
    ] = allTestTypesInternal.COMMON
    if (
      newSettings.applyEBSR &&
      (![
        evalTypeLabels.PARTIAL_CREDIT,
        evalTypeLabels.PARTIAL_CREDIT_IGNORE_INCORRECT,
      ].includes(newSettings.scoringType) ||
        !multipartItems)
    ) {
      newSettings.applyEBSR = false
    }
    if (userRole === roleuser.TEACHER && newSettings.testContentVisibility) {
      delete newSettings.testContentVisibility
    }
    // Below if block is to sanitize any legacy settings template for School Admins
    if (
      userRole === roleuser.SCHOOL_ADMIN &&
      newSettings.testType === commonAssessment &&
      canSchoolAdminUseDistrictCommon === false
    ) {
      newSettings.testType = schoolCommonAssessment
    }
    if (
      newSettings.scoringType === evalTypeLabels.PARTIAL_CREDIT_IGNORE_INCORRECT
    ) {
      newSettings.scoringType = evalTypeLabels.PARTIAL_CREDIT
      newSettings.penalty = false
    }
    if (
      newSettings.passwordPolicy !==
      testConstants.passwordPolicy.REQUIRED_PASSWORD_POLICY_DYNAMIC
    ) {
      delete newSettings.passwordExpireIn
    }
    if (
      newSettings.passwordPolicy !==
      testConstants.passwordPolicy.REQUIRED_PASSWORD_POLICY_STATIC
    ) {
      delete newSettings.assignmentPassword
    }
    if (!newSettings.safeBrowser) {
      delete newSettings.sebPassword
    }
    if (!hasSections && 'preventSectionNavigation' in newSettings) {
      delete newSettings.preventSectionNavigation
    }
    if (!hasSections && 'lockSections' in newSettings) {
      delete newSettings.lockSections
    }
    return newSettings
  }

  handleSettingsSelection = (value) => {
    const {
      setTestData,
      testSettingsList,
      testDefaultSettings,
      entity,
      totalItems,
    } = this.props
    const { settingId: currentSettingsId = '' } = entity
    if (value === 'save-settings-option') {
      if (currentSettingsId === '' || currentSettingsId === null)
        this.setState({ showSaveSettingsModal: true })
      else {
        const { _id, title } =
          testSettingsList.find((t) => t._id === currentSettingsId) || {}
        this.setState({
          showUpdateSettingModal: true,
          settingDetails: {
            _id,
            title,
          },
        })
      }
    } else {
      let newSettings = {}
      if (value === '') {
        newSettings = {
          ...testDefaultSettings,
          testContentVisibility:
            testDefaultSettings.testContentVisibility ||
            contentVisiblityOptions.ALWAYS,
        }
        if (entity.hasSections) {
          newSettings.lockSections = false
          newSettings.preventSectionNavigation = false
        }
      } else {
        const selectedSetting = testSettingsList.find((t) => t._id === value)
        newSettings = {
          ...pick(
            selectedSetting,
            getSettingsToSaveOnTestType(entity.isDocBased)
          ),
        }
      }
      newSettings = this.sanitizeSettingsForTest(newSettings)
      if (newSettings.timedAssignment && !newSettings.allowedTime) {
        newSettings.allowedTime = totalItems * 60 * 1000
      } else if (!newSettings.timedAssignment) {
        newSettings.allowedTime = 0
      }
      newSettings.settingId = value
      setTestData(newSettings)
    }
  }

  toggleSaveSettingsModal = (value) => {
    this.setState({ showSaveSettingsModal: value })
  }

  validateSettings = (entity) => {
    let isValid = true
    if (
      entity.passwordPolicy ===
        testConstants.passwordPolicy.REQUIRED_PASSWORD_POLICY_DYNAMIC &&
      !entity.passwordExpireIn
    ) {
      notification({ msg: 'Please enter password expiry time' })
      isValid = false
    } else if (
      entity.passwordPolicy ===
        testConstants.passwordPolicy.REQUIRED_PASSWORD_POLICY_STATIC &&
      (!entity.assignmentPassword ||
        (entity.assignmentPassword &&
          (entity?.assignmentPassword?.length < 6 ||
            entity?.assignmentPassword?.length > 25)))
    ) {
      notification({ messageKey: 'enterValidPassword' })
      isValid = false
    } else if (entity.safeBrowser && !entity.sebPassword) {
      notification({ msg: 'Please enter safe exam browser password' })
      isValid = false
    }
    return isValid
  }

  // This function is used to get the current settings for the test.
  getCurrentSettings = (title, currentSelectedSettings = {}) => {
    const { entity, userId } = this.props
    const obj = pick(
      { ...currentSelectedSettings, ...entity },
      getSettingsToSaveOnTestType(entity.isDocBased)
    )
    const settings = {
      ...obj,
      dynamicPasswordScope: obj.dynamicPasswordScope || 'class',
      orgId: userId,
      orgType: roleuser.ORG_TYPE.USER,
      title,
    }
    const sanitizedSettings = this.sanitizeSettingsForTest(settings)
    const isValid = this.validateSettings(sanitizedSettings)
    if (isValid) return sanitizedSettings
    return false
  }

  handleSaveTestSetting = (settingName) => {
    const { saveTestSettings } = this.props
    const data = this.getCurrentSettings(settingName)
    if (data) saveTestSettings({ data, switchSettingInTest: true })
    this.toggleSaveSettingsModal(false)
  }

  handleDeleteSettings = (value) => {
    if (value) {
      const { deleteTestSettingRequest, entity, userId } = this.props
      const { settingDetails } = this.state
      deleteTestSettingRequest({
        testSettingsId: settingDetails._id,
        orgId: userId,
      })
      if (settingDetails._id === entity.settingId)
        this.handleSettingsSelection('')
    }
    this.setState({ showDeleteSettingModal: false })
  }

  handleUpdateSettings = (value) => {
    if (!value) {
      const { testSettingsList } = this.props
      this.setState({
        showUpdateSettingModal: false,
        showSaveSettingsModal:
          testSettingsList.length < TEST_SETTINGS_SAVE_LIMIT,
      })
    } else {
      const { updateTestSettingRequest, testSettingsList, entity } = this.props
      const { settingId: currentSettingsId = '' } = entity
      const currentSelectedSetting =
        testSettingsList.find((t) => t._id === currentSettingsId) || {}
      const data = this.getCurrentSettings(
        currentSelectedSetting.title,
        currentSelectedSetting
      )
      if (data) {
        const settings = {
          ...data,
          testSettingId: currentSettingsId,
        }
        updateTestSettingRequest(settings)
      }

      this.setState({
        showUpdateSettingModal: false,
      })
    }
  }

  getSettingCategories = () => {
    const { hasSections } = this.props
    const settingCategories = [...defaultSettingCategories]
    if (!hasSections) return settingCategories

    const hasSectionsSettings = {
      id: 'section-settings',
      title: 'Section Settings',
      type: 'settings-category',
    }
    settingCategories.splice(
      defaultSettingCategories.length - 1,
      0,
      hasSectionsSettings
    )
    return settingCategories
  }

  handleUpdateRefMaterial = (value) => {
    const { setTestData } = this.props
    setTestData({ referenceDocAttributes: value })
  }

  testInstructionsJoyrideCallback = (data) => {
    const { setViewedTutorials, viewedTutorials, entity } = this.props
    const hasInstruction = !!entity?.hasInstruction
    const { COMPLETE } = LIFECYCLE
    const { CLOSE, NEXT } = ACTIONS

    this.scrollToTestInstructionSettings()
    this.setTestInstructionsJoyrideStepStyles()

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(data.type)) {
      const nextStepIndex = data.index + (data.action === ACTIONS.PREV ? -1 : 1)
      this.setState({ testInstructionsJoyrideStepIndex: nextStepIndex })
      if (data.index === 0 && data.action === ACTIONS.NEXT) {
        if (this.previousHasInstruction === undefined) {
          this.previousHasInstruction = !!hasInstruction
        }
        this.updateTestData('hasInstruction')(true)
      } else if (data.index === 1 && data.action === ACTIONS.PREV) {
        this.updateTestData('hasInstruction')(
          this.previousHasInstruction ?? hasInstruction
        )
      }
    }

    if (
      data.lifecycle === COMPLETE &&
      (data.action === CLOSE ||
        (data.action === NEXT &&
          data.index ===
            TEST_INSTRUCTIONS_MULTILANGUAGE_TUTORIAL_STEPS.length - 1))
    ) {
      this.setState({ testInstructionsJoyrideRun: false })
      setViewedTutorials([
        ...viewedTutorials,
        tutorials.testInstructionsMultilanguage,
      ])
    }
  }

  render() {
    const {
      showPassword,
      _releaseGradeKeys,
      isTestBehaviorGroupExpanded,
      isAntiCheatingGroupExpanded,
      isMiscellaneousGroupExpanded,
      isSectionsGroupExpanded,
      warningKeypadSelection,
      warningFreezeSetting,
      showSaveSettingsModal,
      showDeleteSettingModal,
      settingDetails,
      showUpdateSettingModal,
      isStudentToolsGroupExpanded,
      isAccommodationsExpanded,
      sebPasswordErrorMessage,
      testInstructionsJoyrideRun,
      testInstructionsJoyrideStepIndex,
    } = this.state
    const {
      current,
      history,
      windowWidth,
      entity,
      owner,
      userRole,
      features,
      isEditable,
      sebPasswordRef,
      showCancelButton,
      disableAnswerOnPaper,
      premium,
      allowedToSelectMultiLanguage,
      testAssignments,
      editEnable,
      isCurator,
      isPlaylist,
      isEtsDistrict,
      t: i18translate,
      testSettingsList = [],
      performanceBandsData,
      standardsData,
      defaultTestTypeProfiles,
      togglePenaltyOnUsingHints,
      isAiEvaulationDistrict,
      hasSections,
      canSchoolAdminUseDistrictCommon,
      canTeacherAuthorCommonTests,
      districtTestSettings,
      isSurveyTest,
      isNormalSectionsTest,
      isUserDistrictSuperAdmin,
      userPermissions,
      subscription: { subType } = {},
      userTestTypesInternal,
      allTestTypesInternal,
      viewedTutorials,
      districtState,
    } = this.props
    const {
      isDocBased,
      releaseScore,
      safeBrowser,
      sebPassword,
      blockNavigationToAnsweredQuestions,
      shuffleQuestions,
      shuffleAnswers,
      answerOnPaper,
      passwordPolicy,
      maxAnswerChecks,
      testType,
      calcTypes,
      assignmentPassword,
      passwordExpireIn,
      markAsDone,
      maxAttempts,
      grades,
      subjects,
      testContentVisibility,
      playerSkinType = playerSkinTypes.edulastic.toLowerCase(),
      showMagnifier = true,
      timedAssignment,
      allowedTime,
      enableScratchpad = true,
      enableUploadWork = true,
      allowTeacherRedirect = true,
      freezeSettings = false,
      hasInstruction = false,
      preventSectionNavigation = false,
      lockSections = false,

      testletConfig = {},
      restrictNavigationOut,
      restrictNavigationOutAttemptsThreshold,
      blockSaveAndContinue,
      pauseAllowed,
      itemGroups = [],
      applyEBSR = false,
      enableSkipAlert = false,
      settingId: currentSettingsId = '',
      referenceDocAttributes,
      showRubricToStudents = false,
      performanceBand: _performanceBand,
      standardGradingScale: _standardGradingScale,
      showHintsToStudents = true,
      penaltyOnUsingHints = 0,
      allowAutoEssayEvaluation = false,
      vqPreventSkipping,
      vqEnableClosedCaption,
      vqEnableSpeedControl,
      adaptiveDelivery = {},
      isTestContentRestrictedBySuperAdmin,
      showImmersiveReader,
      showSpeechToText,
      showTextToSpeech,
      stackedTranslation,
      showTtsForPassages = true,
      multiLanguageEnabled,
      dynamicPasswordScope,
      showInstructionAcknowledgement = false,
    } = entity

    const showRefMaterial = !isDocBased
    const isSectionAdaptiveTest = !isEmpty(adaptiveDelivery)

    const isVideoQuiz = entity.testCategory === testCategoryTypes.VIDEO_BASED

    // Updating the SettingCatogeries based on hasSections field
    const settingCategories = this.getSettingCategories()

    const availableTestTypes = getAvailableTestTypesForUser({
      isPremium: premium,
      role: userRole,
      canSchoolAdminUseDistrictCommon,
      canTeacherAuthorCommonTests:
        canTeacherAuthorCommonTests &&
        subType === subscriptions.SUBSCRIPTION_SUB_TYPES.ENTERPRISE,
      userTestTypesInternal,
    })

    const testTypes = includeCommonOnTestType(
      availableTestTypes,
      testType,
      allTestTypesInternal,
      userTestTypesInternal
    )
    if (!isSurveyTest) {
      delete testTypes[TEST_TYPE_SURVEY]
    }
    let isSettingPresent = false
    if (
      currentSettingsId &&
      testSettingsList.some((s) => s._id === currentSettingsId)
    ) {
      isSettingPresent = true
    }
    const scoringType =
      entity.scoringType === evalTypeLabels.PARTIAL_CREDIT &&
      entity.penalty === false
        ? evalTypeLabels.PARTIAL_CREDIT_IGNORE_INCORRECT
        : entity.scoringType
    const multipartItems = itemGroups
      .map((o) => o.items)
      .flat()
      .filter((o) => o.multipartItem).length
    const breadcrumbData = [
      {
        title: showCancelButton ? 'ASSIGNMENTS / EDIT TEST' : 'TESTS',
        to: showCancelButton ? '/author/assignments' : '/author/tests',
      },
      {
        title: current,
        to: '',
      },
    ]

    const [commonAssessment] = allTestTypesInternal.COMMON
    const showIsTestContentRestrictedBySuperAdminCheckbox =
      isUserDistrictSuperAdmin &&
      getAllTestTypesWithBaseType(userTestTypesInternal, [
        commonAssessment,
      ]).includes(testType)

    const isShowRubricToStudentsSettingVisible = showRubricToStudentsSetting(
      itemGroups
    )
    const isShowAutoEssayEvaluationSetting = showAutoEssayEvaluationSetting(
      itemGroups
    )
    const isSmallSize = windowWidth < 993 ? 1 : 0

    let validationMessage = ''
    const isPasswordValid = () => {
      const { inputBlur } = this.state
      if (!inputBlur) return blueBorder
      if (assignmentPassword.split(' ').length > 1) {
        validationMessage = 'Password must not contain space'
        return red
      }
      if (assignmentPassword.length >= 6 && assignmentPassword.length <= 25) {
        return green
      }
      validationMessage =
        'Password is too short - must be at least 6 characters'
      if (assignmentPassword.length > 25)
        validationMessage = 'Password is too long'
      return red
    }

    const categories = ['show-answer-choice', 'suffle-question']

    const availableFeatures = {}
    settingsList.slice(0, -5).forEach((category) => {
      if (isDocBased && categories.includes(category.id)) return null
      if (
        features[settingCategoriesFeatureMap[category.id]] ||
        isFeatureAccessible({
          features,
          inputFeatures: settingCategoriesFeatureMap[category.id],
          gradeSubject: { grades, subjects },
        })
      ) {
        availableFeatures[settingCategoriesFeatureMap[category.id]] = true
      }
      return null
    })

    const pearOrEdulasticText = isPearDomain
      ? pearAssessmentText
      : playerSkinTypes.edulastic
    const testTypeToCheckForEdulasticSkin =
      userTestTypesInternal[testType]?.baseType || testType
    const edulastic = `${pearOrEdulasticText} ${
      testTypeToCheckForEdulasticSkin.includes('assessment')
        ? 'Test'
        : 'Practice'
    }`
    const skinTypes = {
      ...playerSkinTypes,
      edulastic,
    }

    const accessibilityData = [
      {
        key: magnifier.key,
        value: showMagnifier,
        description: i18translate(
          'accessibilitySettings.magnifier.description'
        ),
        id: magnifier.id,
      },
      {
        key: scratchPad.key,
        value: enableScratchpad,
        description: i18translate(
          'accessibilitySettings.scratchPad.description'
        ),
        id: scratchPad.id,
      },
      {
        key: skipAlert.key,
        value: enableSkipAlert,
        description: i18translate(
          'accessibilitySettings.skipAlert.description'
        ),
        id: skipAlert.id,
      },
    ]

    if (districtTestSettings?.enableUploadWork) {
      accessibilityData.push({
        key: uploadWork.key,
        value: enableUploadWork,
        description: i18translate(
          'accessibilitySettings.uploadWork.description'
        ),
        id: uploadWork.id,
      })
    }

    const isTestlet =
      playerSkinType?.toLowerCase() === playerSkinValues.testlet.toLowerCase()

    const advancedSettingCategoris = settingCategories.slice(-6, -4)
    if (isTestlet) {
      advancedSettingCategoris.push({
        id: 'external-metadata',
        title: 'External Metadata',
      })
    }

    const {
      assessmentSuperPowersMarkAsDone = false,
      assessmentSuperPowersShowCalculator = false,
      assessmentSuperPowersTimedTest = false,
      assessmentSuperPowersCheckAnswerTries = false,
      maxAttemptAllowed = false,
      assessmentSuperPowersShuffleQuestions = false,
      assessmentSuperPowersShuffleAnswerChoice = false,
      assessmentSuperPowersRequirePassword = false,
      assessmentSuperPowersRestrictQuestionBackNav = false,
      assessmentSuperPowersRequireSafeExamBrowser = false,
      assessmentSuperPowersAnswerOnPaper = false,
      performanceBands = false,
      selectPlayerSkinType = false,
    } = availableFeatures

    const navigationThresholdMoreThan1 =
      restrictNavigationOut === 'warn-and-report-after-n-alerts' &&
      restrictNavigationOutAttemptsThreshold > 1
    const isEdulasticCurator = userRole === roleuser.EDULASTIC_CURATOR
    const testStatus = entity.status
    const isRegradeFlow =
      entity.isUsed &&
      !!testAssignments.length &&
      !isEdulasticCurator &&
      !isCurator &&
      (testStatus === 'draft' || editEnable)
    const disabled = !owner || !isEditable

    // Accommodations settings will be visible only for premium & enterprise users
    const {
      accommodationsData,
      accommodationSettingsData,
    } = getAccommodationsSettingOptions({
      i18translate,
      features,
      districtTestSettings,
      userRole,
      disabled,
      premium,
      isTestlet,
      allowedToSelectMultiLanguage,
      showImmersiveReader,
      showSpeechToText,
      showTextToSpeech,
      stackedTranslation,
      isDocBased,
      showTtsForPassages,
      multiLanguageEnabled,
    })

    const performanceBand = pick(
      multiFind(
        performanceBandsData,
        [
          { _id: _performanceBand?._id },
          {
            _id:
              defaultTestTypeProfiles.performanceBand?.[
                getProfileKey(testType, allTestTypesInternal)
              ],
          },
        ],
        _performanceBand
      ),
      ['_id', 'name']
    )
    const standardGradingScale = pick(
      multiFind(
        standardsData,
        [
          { _id: _standardGradingScale?._id },
          {
            _id:
              defaultTestTypeProfiles.standardProficiency?.[
                getProfileKey(testType, allTestTypesInternal)
              ],
          },
        ],
        _standardGradingScale
      ),
      ['_id', 'name']
    )
    const getFilteredCategories = () => {
      const hasAccommodationsData = accommodationSettingsData.filter(
        (a) => a.isEnabled
      ).length
      if (isDocBased || !hasAccommodationsData) {
        return settingCategories.filter(
          (settingCategory) => settingCategory.id !== 'accommodations'
        )
      }
      return settingCategories
    }

    const filteredCategories = getFilteredCategories()

    const applyEBSRComponent = () => {
      return (
        <CheckBoxWrapper>
          <CheckboxLabel
            disabled={disabled}
            data-cy="applyEBSR"
            checked={applyEBSR}
            onChange={this.handleApplyEBSR}
          >
            <StyledSpan className="spanText">
              APPLY EBSR GRADING
              <HelperToolTip
                optionKey={multipartEvaluationTypes.FIRST_CORRECT_MUST}
                placement="topLeft"
                isMultipartSetting
              />
            </StyledSpan>
          </CheckboxLabel>
        </CheckBoxWrapper>
      )
    }

    const isTestSettingSaveLimitReached =
      testSettingsList.length >= TEST_SETTINGS_SAVE_LIMIT

    const disableCheckAnsTries = [
      disabled,
      !assessmentSuperPowersCheckAnswerTries,
      isSurveyTest,
    ].some((o) => !!o)

    const isMultiLanguageEnabled =
      premium && allowedToSelectMultiLanguage && !isDocBased

    return (
      <MainContentWrapper
        role="tabpanel"
        id="settings-panel" // needed for accessibility
        ref={this.containerRef}
        padding="10px 20px"
      >
        {showSaveSettingsModal && (
          <SaveSettingsModal
            visible={showSaveSettingsModal}
            toggleModal={this.toggleSaveSettingsModal}
            handleSave={this.handleSaveTestSetting}
          />
        )}
        <DeleteTestSettingsModal
          visible={showDeleteSettingModal}
          settingDetails={settingDetails}
          handleResponse={this.handleDeleteSettings}
        />
        <UpdateTestSettingsModal
          visible={showUpdateSettingModal}
          settingDetails={settingDetails}
          handleResponse={this.handleUpdateSettings}
          disableSaveNew={isTestSettingSaveLimitReached}
          closeModal={() => {
            this.setState({ showUpdateSettingModal: false })
          }}
        />
        <Container padding="10px 20px" marginTop="0px">
          <Row>
            <Col style={{ lineHeight: '32px' }} xs={24} md={12}>
              <Breadcrumb
                data={breadcrumbData}
                style={{ position: 'relative', top: '0px' }}
              />
            </Col>
            <Col xs={24} md={12}>
              {premium && (
                <SavedSettingsContainer align="right" display="block">
                  <Row gutter={16}>
                    <Col
                      style={{ textAlign: 'right', lineHeight: '32px' }}
                      xs={24}
                      sm={14}
                    >
                      SAVED SETTINGS
                    </Col>
                    <Col xs={24} sm={10} style={{ textAlign: 'right' }}>
                      <Select
                        value={isSettingPresent ? currentSettingsId : ''}
                        getPopupContainer={(node) => node.parentNode}
                        onChange={this.handleSettingsSelection}
                        optionLabelProp="label"
                        data-cy="select-save-test-settings"
                        disabled={disabled}
                      >
                        <Select.Option
                          key="1"
                          value=""
                          label="DEFAULT TEST SETTINGS"
                        >
                          DEFAULT TEST SETTINGS
                        </Select.Option>
                        {testSettingsList.map((ts) => (
                          <Select.Option
                            key={ts._id}
                            value={ts._id}
                            label={ts.title}
                          >
                            <span
                              onMouseOver={this.handleMouseOver}
                              onMouseOut={this.handleMouseOut}
                              onFocus={() => {}}
                              onBlur={() => {}}
                            >
                              {ts.title}{' '}
                              <DeleteIconContainer
                                className="delete-setting-button"
                                onClick={(e) => {
                                  e.preventDefault()
                                  e.stopPropagation()
                                  this.setState({
                                    showDeleteSettingModal: true,
                                    settingDetails: {
                                      _id: ts._id,
                                      title: ts.title,
                                    },
                                  })
                                }}
                                title="Remove Setting"
                              >
                                <IconTrash color={themeColor} />
                              </DeleteIconContainer>
                            </span>
                          </Select.Option>
                        ))}
                        <Select.Option
                          key="2"
                          value="save-settings-option"
                          label="SAVE CURRENT SETTING"
                          disabled={
                            isTestSettingSaveLimitReached && !currentSettingsId
                          }
                          title={
                            isTestSettingSaveLimitReached && !currentSettingsId
                              ? 'Maximum limit reached. Please delete existing one to add new.'
                              : ''
                          }
                          className="save-settings-option"
                        >
                          <span>
                            <Icon type="save" theme="filled" />
                            SAVE CURRENT SETTING
                          </span>
                        </Select.Option>
                      </Select>
                    </Col>
                  </Row>
                </SavedSettingsContainer>
              )}
            </Col>
          </Row>
          <Row>
            <Col span={isSmallSize ? 0 : 4}>
              <NavigationMenu>
                <StyledAnchor
                  affix={false}
                  offsetTop={125}
                  getContainer={() => this.containerRef.current || window}
                >
                  {filteredCategories.map((category) => {
                    return (
                      <Anchor.Link
                        key={category.id}
                        href={sanitizeUrl(
                          `${history.location.pathname}#${category.id}`
                        )}
                        title={category.title.toLowerCase()}
                      />
                    )
                  })}
                </StyledAnchor>
              </NavigationMenu>
            </Col>

            <Col span={isSmallSize ? 24 : 20}>
              <StyledTestSettingFeatureBannerContainer>
                <FeatureBannerPlaceholder
                  skipChecksAndShowBanner
                  placeholderId="test-setting"
                  bannerContainerStyle={{
                    marginLeft: '0px',
                    height: '50px',
                    justifyContent: 'space-between',
                  }}
                  bannerInfoStyle={{
                    marginLeft: '30px',
                  }}
                />
              </StyledTestSettingFeatureBannerContainer>

              <SettingsCategoryBlock id="test-behavior">
                <h2>Test Behavior</h2>
                <span
                  onClick={() =>
                    this.togglePanel(
                      'isTestBehaviorGroupExpanded',
                      !isTestBehaviorGroupExpanded
                    )
                  }
                  tabIndex={0}
                  role="button"
                  aria-label={`${
                    isTestBehaviorGroupExpanded ? 'Collapse' : 'Expand'
                  } test behavior group.`}
                  aria-expanded={isTestBehaviorGroupExpanded}
                  aria-controls="test-behavior"
                  onKeyDown={(e) =>
                    onEnterKeyPressHandler(e, () =>
                      this.togglePanel(
                        'isTestBehaviorGroupExpanded',
                        !isTestBehaviorGroupExpanded
                      )
                    )
                  }
                >
                  <Icon type={isTestBehaviorGroupExpanded ? 'minus' : 'plus'} />
                </span>
              </SettingsCategoryBlock>
              {isTestBehaviorGroupExpanded && (
                <>
                  <Block id="test-type" smallSize={isSmallSize}>
                    <Row>
                      <Title>
                        <span>Test Type</span>
                        {isRegradeFlow && !isPlaylist && (
                          <Tooltip
                            title="Updates made to the test type will not reflect for existing assignments after regrade."
                            trigger={['hover', 'focus']}
                          >
                            <IconInfo
                              color={lightGrey9}
                              style={{ marginLeft: '10px', cursor: 'pointer' }}
                            />
                          </Tooltip>
                        )}
                      </Title>
                      <Body smallSize={isSmallSize}>
                        {canTeacherAuthorCommonTests &&
                        subType ===
                          subscriptions.SUBSCRIPTION_SUB_TYPES.ENTERPRISE &&
                        testType !== TEST_TYPE_SURVEY ? (
                          <AdvancedTestTypeSelection
                            disabled={disabled}
                            testType={testType}
                            testTypes={testTypes}
                            updateTestData={this.updateTestData}
                            userRole={userRole}
                            testId={entity._id}
                            adminCoAuthors={entity.adminCoAuthors}
                            testStatus={entity.status}
                            userPermissions={userPermissions}
                            allTestTypesInternal={allTestTypesInternal}
                            userTestTypesInternal={userTestTypesInternal}
                          />
                        ) : (
                          <>
                            <Row>
                              <Col xs={24} sm={12}>
                                <SelectInputStyled
                                  value={testType}
                                  disabled={
                                    disabled || testType === TEST_TYPE_SURVEY
                                  }
                                  onChange={this.updateTestData('testType')}
                                  getPopupContainer={(trigger) =>
                                    trigger.parentNode
                                  }
                                  data-cy="testType"
                                >
                                  {Object.keys(testTypes).map((key) => (
                                    <Option key={key} value={key}>
                                      {testTypes[key]}
                                    </Option>
                                  ))}
                                </SelectInputStyled>
                              </Col>
                            </Row>
                            <Description>
                              Designate what type of assignment you are
                              delivering. You’ll be able to use these categories
                              later to filter reports so make sure practice is
                              set as practice.
                            </Description>
                          </>
                        )}
                      </Body>
                    </Row>
                  </Block>
                  {/* VQ prevent skipping */}

                  <EduIf
                    condition={
                      entity.testCategory === testCategoryTypes.VIDEO_BASED
                    }
                  >
                    <Block id="vq-prevent-skipping" smallSize={isSmallSize}>
                      <Title>
                        <span>Prevent Skipping</span>
                        <EduSwitchStyled
                          checked={vqPreventSkipping}
                          data-cy="vqPreventSkipping"
                          onChange={(v) =>
                            this.updateTestData('vqPreventSkipping')(v)
                          }
                          disabled={disabled}
                        />
                      </Title>
                      <Body smallSize={isSmallSize}>
                        <Description data-cy="preventSkippingDescription">
                          If <b>ON</b>, Students won&apos;t be able to skip
                          ahead in a video.
                        </Description>
                      </Body>
                    </Block>
                    {/* VQ prevent skipping */}

                    {/* VQ enable cc */}
                    <Block id="vq-enable-cc" smallSize={isSmallSize}>
                      <Title>
                        <span>Turn on closed captions</span>
                        <EduSwitchStyled
                          checked={vqEnableClosedCaption}
                          data-cy="vqEnableClosedCaption"
                          onChange={(v) =>
                            this.updateTestData('vqEnableClosedCaption')(v)
                          }
                          disabled={disabled}
                        />
                      </Title>
                      <Body smallSize={isSmallSize}>
                        <Description>
                          Enable closed captions if available for YouTube
                          videos.
                        </Description>
                      </Body>
                    </Block>
                    {/* VQ enable cc */}
                    {/* VQ enable speed control */}
                    <Block id="vq-enable-sp" smallSize={isSmallSize}>
                      <Title>
                        <span>Speed up videos</span>
                        <EduSwitchStyled
                          checked={vqEnableSpeedControl}
                          data-cy="vqEnableSpeedControl"
                          onChange={(v) =>
                            this.updateTestData('vqEnableSpeedControl')(v)
                          }
                          disabled={disabled}
                        />
                      </Title>
                      <Body smallSize={isSmallSize}>
                        <Description>
                          Allow students to watch videos at 1.25, 1.5, 1.75, or
                          2 times their normal speed (students can always slow
                          down videos).
                        </Description>
                      </Body>
                    </Block>
                    {/* VQ enable speed control */}
                  </EduIf>

                  {allTestTypesInternal.COMMON.includes(testType) && (
                    <Block id="allow-redirect" smallSize={isSmallSize}>
                      <SettingContainer>
                        <Title>
                          <span>Allow Teachers to Redirect</span>
                          <EduSwitchStyled
                            disabled={disabled}
                            data-cy="allow-redirect"
                            checked={allowTeacherRedirect}
                            onChange={() =>
                              this.updateTestData('allowTeacherRedirect')(
                                !allowTeacherRedirect
                              )
                            }
                          />
                        </Title>
                        <Body smallSize={isSmallSize}>
                          <Description>
                            When allow teachers to redirect is set to ON,
                            teachers are allowed to redirect a common test for
                            their class. Set to OFF to prevent teachers from
                            using the redirect test feature.
                          </Description>
                        </Body>
                      </SettingContainer>
                    </Block>
                  )}

                  {allTestTypesInternal.COMMON.includes(testType) && (
                    <Block id="freeze-settings" smallSize={isSmallSize}>
                      <Row>
                        <Title>
                          <ConfirmationModal
                            centered
                            title="Confirm Turning Off Freeze Settings"
                            visible={warningFreezeSetting}
                            footer={[
                              <EduButton
                                isGhost
                                onClick={() =>
                                  this.confirmFreezeSettingsDisable(false)
                                }
                              >
                                CANCEL
                              </EduButton>,
                              <EduButton
                                onClick={() =>
                                  this.confirmFreezeSettingsDisable(true)
                                }
                              >
                                TURN OFF
                              </EduButton>,
                            ]}
                            textAlign="center"
                            onCancel={() =>
                              this.confirmFreezeSettingsDisable(false)
                            }
                          >
                            <div style={{ textAlign: 'left' }}>
                              <p style={{ fontWeight: 400, color: 'black' }}>
                                Please note, if this settings is <b>OFF</b>,
                                when this Common Assessment is assigned by
                                teachers, it will <b>automatically change</b> to
                                a <b>Class Assessment</b>
                              </p>
                              <p
                                style={{
                                  fontWeight: 400,
                                  color: 'black',
                                  marginTop: '20px',
                                }}
                              >
                                <IconWarnTriangle
                                  style={{
                                    marginRight: '5px',
                                    marginBottom: '-3px',
                                  }}
                                />
                                This is <b>not recommended</b> for
                                district/school-wide Common Test administration,
                                as Class Assessments will not appear under
                                Common Test filter in assignment/reports,
                                leading to data analysis and visibility issues
                                for admins.
                              </p>
                            </div>
                          </ConfirmationModal>
                          <span>Freeze Settings</span>

                          <Tooltip
                            title={
                              !(
                                userRole === roleuser.DISTRICT_ADMIN ||
                                userRole === roleuser.SCHOOL_ADMIN
                              )
                                ? 'This setting can be changed by admins only'
                                : ''
                            }
                            trigger={['hover', 'focus']}
                          >
                            <EduSwitchStyled
                              disabled={
                                disabled ||
                                !(
                                  userRole === roleuser.DISTRICT_ADMIN ||
                                  userRole === roleuser.SCHOOL_ADMIN
                                )
                              }
                              data-cy="freeze-settings"
                              checked={freezeSettings}
                              onChange={() =>
                                this.toggleFreezeSettings(freezeSettings)
                              }
                            />
                          </Tooltip>
                          <Tooltip
                            tabIndex={0}
                            aria-label="Freeze setting info Tooltip"
                            aria-describedby="freeze-setting-tooltip"
                            title="Instructors won’t be allowed to override the test settings while assigning it."
                            trigger={['hover', 'focus']}
                          >
                            <IconInfo
                              color={lightGrey9}
                              style={{
                                cursor: 'pointer',
                                position: 'relative',
                                right: '-10px',
                              }}
                              tabIndex={0}
                              aria-label="Freeze setting info Tooltip"
                              aria-describedby="freeze-setting-tooltip"
                            />
                          </Tooltip>
                        </Title>
                      </Row>
                    </Block>
                  )}
                  {isMultiLanguageEnabled &&
                    !viewedTutorials.includes(
                      tutorials.testInstructionsMultilanguage
                    ) && (
                      <EduJoyride
                        steps={TEST_INSTRUCTIONS_MULTILANGUAGE_TUTORIAL_STEPS}
                        callback={this.testInstructionsJoyrideCallback}
                        locale={{
                          close: 'Done',
                          last: 'Done',
                        }}
                        showProgress
                        options={{ zIndex: 1015 }}
                        continuous
                        disableScrolling
                        stepIndex={testInstructionsJoyrideStepIndex}
                        run={testInstructionsJoyrideRun}
                      />
                    )}
                  {/* Add instruction starts */}
                  <Block id="add-instruction" smallSize={isSmallSize}>
                    <SettingContainer data-joyride-id="testInstructionsToggle">
                      <Title>
                        <span>Test Instructions</span>
                        <EduSwitchStyled
                          disabled={disabled}
                          data-cy="add-test-instruction"
                          checked={hasInstruction}
                          onChange={() =>
                            this.updateTestData('hasInstruction')(
                              !hasInstruction
                            )
                          }
                        />
                      </Title>
                      <Body smallSize={isSmallSize}>
                        <div data-joyride-id="testInstructions">
                          {isMultiLanguageEnabled ? (
                            !hasInstruction ? (
                              <Description>
                                Deliver Test Instructions in student&apos;s
                                preferred language with Text to Speech.
                                Optionally require acknowledgment before student
                                start the assignment.
                              </Description>
                            ) : null
                          ) : (
                            <Description>
                              Add instructions for the students here. For
                              example, &ldquo;You will be allowed two attempts
                              on this quiz.&rdquo; Or, &ldquo;This test is worth
                              30% of your grade.&rdquo;
                            </Description>
                          )}

                          {hasInstruction && (
                            <Instruction
                              border="border"
                              size="SM"
                              updateTestData={this.updateTestData}
                              disabled={disabled}
                              showInstructionAcknowledgement={
                                showInstructionAcknowledgement
                              }
                              test={entity}
                              currentSettingsId={currentSettingsId}
                              isDocBased={isDocBased}
                              isMultiLanguageEnabled={isMultiLanguageEnabled}
                            />
                          )}
                        </div>
                      </Body>
                    </SettingContainer>
                  </Block>
                  {/* Add instruction ends */}

                  <Block id="release-scores" smallSize={isSmallSize}>
                    <Title>
                      Release Scores{' '}
                      {releaseScore === releaseGradeLabels.DONT_RELEASE
                        ? '[OFF]'
                        : '[ON]'}
                    </Title>
                    <Body smallSize={isSmallSize}>
                      <StyledRadioGroup
                        disabled={disabled}
                        onChange={this.updateFeatures('releaseScore')}
                        value={releaseScore}
                      >
                        {_releaseGradeKeys.map((item) => (
                          <RadioBtn value={item} key={item}>
                            {releaseGradeTypes[item]}
                          </RadioBtn>
                        ))}
                      </StyledRadioGroup>
                      <Description>
                        Decide what students immediately get to see upon
                        submitting an assessment.
                      </Description>
                    </Body>
                  </Block>

                  <Block id="evaluation-method" smallSize={isSmallSize}>
                    <SettingContainer>
                      <Title>Evaluation Method</Title>
                      <Body smallSize={isSmallSize}>
                        <Row>
                          <Col xs={24} sm={8}>
                            <StyledRadioGroup
                              disabled={
                                disabled || testType === TEST_TYPE_SURVEY
                              }
                              onChange={(e) =>
                                this.updateTestData('scoringType')(
                                  e.target.value
                                )
                              }
                              value={scoringType}
                            >
                              <RadioBtn
                                value={ALL_OR_NOTHING}
                                data-cy={ALL_OR_NOTHING}
                                key={ALL_OR_NOTHING}
                              >
                                {evalTypes.ALL_OR_NOTHING}
                              </RadioBtn>
                              <RadioBtn
                                value={PARTIAL_CREDIT}
                                data-cy={PARTIAL_CREDIT}
                                key={PARTIAL_CREDIT}
                              >
                                {evalTypes.PARTIAL_CREDIT}
                                {scoringType === PARTIAL_CREDIT &&
                                multipartItems &&
                                premium
                                  ? applyEBSRComponent()
                                  : null}
                              </RadioBtn>
                              <RadioBtn
                                value={PARTIAL_CREDIT_IGNORE_INCORRECT}
                                data-cy={PARTIAL_CREDIT_IGNORE_INCORRECT}
                                key={PARTIAL_CREDIT_IGNORE_INCORRECT}
                              >
                                {evalTypes.PARTIAL_CREDIT_IGNORE_INCORRECT}
                                {scoringType ===
                                  PARTIAL_CREDIT_IGNORE_INCORRECT &&
                                multipartItems &&
                                premium
                                  ? applyEBSRComponent()
                                  : null}
                              </RadioBtn>
                              {/* ant-radio-wrapper already has bottom-margin: 18px by default. */}
                              {/* not setting mb (margin bottom) as it is common component */}
                              <RadioBtn
                                value={ITEM_LEVEL_EVALUATION}
                                data-cy={ITEM_LEVEL_EVALUATION}
                                key={ITEM_LEVEL_EVALUATION}
                                style={{ marginBottom: '0px' }}
                              >
                                {evalTypes.ITEM_LEVEL_EVALUATION}
                              </RadioBtn>
                            </StyledRadioGroup>
                          </Col>
                          <Col xs={24} sm={16}>
                            <Description>
                              Choose if students should be awarded partial
                              credit for their answers or not. If partial credit
                              is allowed, then choose whether the student should
                              be penalized for incorrect answers or not
                              (applicable only for multiple selection question
                              and multi part question with multiple selection
                              widgets)
                            </Description>
                          </Col>
                        </Row>
                      </Body>
                    </SettingContainer>
                  </Block>

                  {!isVideoQuiz && (
                    <Block id="mark-as-done" smallSize={isSmallSize}>
                      <SettingContainer>
                        <Title>
                          Mark as Done{' '}
                          <DollarPremiumSymbol
                            premium={assessmentSuperPowersMarkAsDone}
                          />
                        </Title>
                        <Body smallSize={isSmallSize}>
                          <Row type="flex" align="middle">
                            <Col xs={24} sm={8}>
                              <StyledRadioGroup
                                disabled={
                                  disabled || !assessmentSuperPowersMarkAsDone
                                }
                                onChange={this.updateFeatures('markAsDone')}
                                value={markAsDone}
                              >
                                {Object.keys(completionTypes).map((item) => (
                                  <RadioBtn
                                    value={completionTypes[item]}
                                    key={completionTypes[item]}
                                    data-cy={`mark-as-done-${completionTypes[item]}`}
                                  >
                                    {completionTypes[item]}
                                  </RadioBtn>
                                ))}
                              </StyledRadioGroup>
                            </Col>
                            <Col xs={24} sm={16}>
                              <Description>
                                When an assignment is marked “Done”, data flows
                                to the reports. Automatically will mark it as
                                done when all students are graded and the due
                                date has passed, OR choose Manually and select
                                the Mark as Done button when ready.
                              </Description>
                            </Col>
                          </Row>
                        </Body>
                      </SettingContainer>
                    </Block>
                  )}

                  {!isSectionAdaptiveTest && !isVideoQuiz && (
                    <Block id="timed-test" smallSize={isSmallSize}>
                      <SettingContainer>
                        <Title>
                          <span>
                            Timed Test{' '}
                            <DollarPremiumSymbol
                              premium={assessmentSuperPowersTimedTest}
                            />
                          </span>
                          <Tooltip
                            role="tooltip"
                            id="timed-test-setting-tooltip"
                            trigger={['hover', 'focus']}
                            title="Timed test allows you to control how long students have to take the test. When the time limit is reached, students will be locked out of the assessment. Choose the time and whether students can pause and continue later or if the test should be taken in a single sitting."
                          >
                            <IconInfo
                              color={lightGrey9}
                              style={{
                                marginLeft: '10px',
                                cursor: 'pointer',
                              }}
                              tabIndex={0}
                              aria-label="Timed test setting info Tooltip"
                              aria-describedby="timed-test-setting-tooltip"
                            />
                          </Tooltip>
                          <EduSwitchStyled
                            disabled={
                              disabled || !assessmentSuperPowersTimedTest
                            }
                            checked={timedAssignment}
                            data-cy="assignment-time-switch"
                            onChange={this.updateTimedTest('timedAssignment')}
                            aria-label={`Timed Test ${
                              timedAssignment ? 'enabled' : 'disabled'
                            }`}
                          />
                        </Title>
                        <Body smallSize={isSmallSize}>
                          <Row type="flex" align="middle">
                            <Col xs={24} sm={8}>
                              {timedAssignment && (
                                <>
                                  {/* eslint-disable no-restricted-globals */}
                                  <TextInputStyled
                                    type="number"
                                    width="100px"
                                    size="large"
                                    data-cy="assignment-time"
                                    style={{ margin: '0px 20px 0px 0px' }}
                                    value={
                                      !isNaN(allowedTime)
                                        ? allowedTime / (60 * 1000) || ''
                                        : 1
                                    }
                                    onChange={(e) => {
                                      if (e.target.value <= 300) {
                                        this.updateTestData('allowedTime')(
                                          e.target.value * 60 * 1000
                                        )
                                      }
                                    }}
                                    min={1}
                                    max={300}
                                    step={1}
                                  />
                                  <Label>Minutes</Label>
                                  {/* eslint-enable no-restricted-globals */}
                                </>
                              )}
                            </Col>
                            <Col xs={24} sm={16}>
                              {timedAssignment && (
                                <CheckboxLabel
                                  checked={pauseAllowed}
                                  disabled={disabled}
                                  data-cy="exit-allowed"
                                  onChange={(e) =>
                                    this.updateTestData('pauseAllowed')(
                                      e.target.checked
                                    )
                                  }
                                >
                                  Allow student to save and continue later.
                                </CheckboxLabel>
                              )}
                            </Col>
                          </Row>
                          <Description style={{ marginTop: '10px' }}>
                            Timed test allows you to control how long students
                            have to take the test. When the time limit is
                            reached, students will be locked out of the
                            assessment. Choose the time and whether students can
                            pause and continue later or if the test should be
                            taken in a single sitting.
                          </Description>
                        </Body>
                      </SettingContainer>
                    </Block>
                  )}

                  <Block id="maximum-attempts-allowed">
                    <SettingContainer>
                      <Title>
                        Maximum Attempts Allowed{' '}
                        <DollarPremiumSymbol premium={maxAttemptAllowed} />
                      </Title>
                      <Body>
                        <TextInputStyled
                          type="number"
                          width="100px"
                          disabled={disabled || !maxAttemptAllowed}
                          size="large"
                          value={maxAttempts}
                          onChange={this.updateAttempt}
                          min={1}
                          step={1}
                        />
                        <Description>
                          Select the number of times a student can attempt the
                          test. Note, this can be overridden at a later time in
                          the settings if necessary.
                        </Description>
                      </Body>
                    </SettingContainer>
                  </Block>

                  <Block
                    id="check-answer-tries-per-question"
                    smallSize={isSmallSize}
                  >
                    <SettingContainer>
                      <Title>
                        Check Answer Tries Per Question{' '}
                        <DollarPremiumSymbol
                          premium={assessmentSuperPowersCheckAnswerTries}
                        />
                      </Title>
                      <Body smallSize={isSmallSize}>
                        <Row gutter={24}>
                          <Col span={12}>
                            <TextInputStyled
                              disabled={disableCheckAnsTries}
                              onChange={(e) =>
                                this.updateTestData('maxAnswerChecks')(
                                  e.target.value
                                )
                              }
                              size="large"
                              width="160px"
                              value={maxAnswerChecks}
                              type="number"
                              min={0}
                              placeholder="Number of tries"
                            />
                          </Col>
                        </Row>
                        <Description>
                          Allow students to check their answer before moving on
                          to the next question. Enter the number of attempts
                          allowed per question.
                        </Description>
                      </Body>
                    </SettingContainer>
                  </Block>

                  {allTestTypesInternal.COMMON.includes(testType) &&
                    (userRole === roleuser.DISTRICT_ADMIN ||
                      userRole === roleuser.SCHOOL_ADMIN) && (
                      <Block
                        id="test-content-visibility"
                        smallSize={isSmallSize}
                      >
                        <Title>{i18translate('contentVisibility.title')}</Title>
                        <Description>
                          {i18translate('contentVisibility.description')}
                        </Description>

                        <Body smallSize={isSmallSize}>
                          <ContentVisibilityOptions
                            isDisabled={disabled}
                            testContentVisibility={testContentVisibility}
                            updateTestContentVisibility={this.updateFeatures(
                              TEST_CONTENT_VISIBILITY
                            )}
                            updateIsTestContentRestrictedBySuperAdmin={this.updateFeatures(
                              'isTestContentRestrictedBySuperAdmin'
                            )}
                            isTestContentRestrictedBySuperAdmin={
                              isTestContentRestrictedBySuperAdmin
                            }
                            showIsTestContentRestrictedBySuperAdminCheckbox={
                              showIsTestContentRestrictedBySuperAdminCheckbox
                            }
                          />
                        </Body>
                      </Block>
                    )}

                  <Block id="answer-on-paper" smallSize={isSmallSize}>
                    <SettingContainer>
                      <Title>
                        <span>
                          Answer on Paper
                          <DollarPremiumSymbol
                            premium={assessmentSuperPowersAnswerOnPaper}
                          />
                        </span>
                        <Tooltip
                          title={
                            isSectionAdaptiveTest
                              ? i18translate(
                                  'notSupportedForSectionsAdaptiveTest.info'
                                )
                              : null
                          }
                        >
                          <EduSwitchStyled
                            disabled={
                              disabled ||
                              disableAnswerOnPaper ||
                              !assessmentSuperPowersAnswerOnPaper ||
                              isSectionAdaptiveTest
                            }
                            checked={answerOnPaper}
                            onChange={this.updateTestData('answerOnPaper')}
                            data-cy="answer-on-paper"
                          />
                        </Tooltip>
                      </Title>
                      <Body smallSize={isSmallSize}>
                        <Description>
                          Use this option if you are administering this
                          assessment on paper. If you use this option, you will
                          have to manually grade student responses after the
                          assessment is closed.
                        </Description>
                      </Body>
                    </SettingContainer>
                  </Block>

                  {testType !== 'testlet' && !isDocBased && (
                    <Block id="player-skin-type" smallSize={isSmallSize}>
                      <Row>
                        <Title>
                          Choose Test Interface{' '}
                          <DollarPremiumSymbol premium={selectPlayerSkinType} />
                        </Title>
                        <Body smallSize={isSmallSize}>
                          <Col xs={24} sm={12}>
                            <SelectInputStyled
                              data-cy="playerSkinType"
                              showSearch
                              filterOption={(input, option) =>
                                option.props.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              value={
                                playerSkinType ===
                                playerSkinTypes.edulastic.toLowerCase()
                                  ? edulastic
                                  : playerSkinType
                              }
                              disabled={disabled || !selectPlayerSkinType}
                              onChange={this.updateTestData('playerSkinType')}
                              getPopupContainer={(trigger) =>
                                trigger.parentNode
                              }
                              ref={(node) => {
                                setSelectSearchAriaLabel(
                                  node,
                                  'Select Test Interface'
                                )
                              }}
                            >
                              {skinTypesOrder(skinTypes, districtState).map(
                                (key, idx) => {
                                  if (key === 'testlet' && !isEtsDistrict) {
                                    return null
                                  }
                                  if (key === 'devider') {
                                    const value = `${key}-${idx}`
                                    return (
                                      <Option
                                        key={value}
                                        value={value}
                                        disabled
                                      >
                                        {'-'.repeat(15)}
                                      </Option>
                                    )
                                  }
                                  return (
                                    <Option key={key} value={key}>
                                      {skinTypes[key]}
                                    </Option>
                                  )
                                }
                              )}
                            </SelectInputStyled>
                          </Col>
                          <Col span={24}>
                            <Description>
                              Teachers can change the look and feel of the
                              assessments to more closely align with formats
                              similar to state and nationally administered
                              assessments. If you don’t see your state, select
                              the generic option,{' '}
                              {isPearDomain
                                ? pearAssessmentText
                                : edulasticText}{' '}
                              Test.
                            </Description>
                          </Col>
                        </Body>
                      </Row>
                    </Block>
                  )}
                </>
              )}
              <SettingsCategoryBlock id="student-tools">
                <h2>
                  Student Tools <DollarPremiumSymbol premium={premium} />
                </h2>
                <span
                  onClick={() =>
                    this.togglePanel(
                      'isStudentToolsGroupExpanded',
                      !isStudentToolsGroupExpanded
                    )
                  }
                  tabIndex={0}
                  role="button"
                  aria-label={`${
                    isStudentToolsGroupExpanded ? 'Collapse' : 'Expand'
                  } student tools group.`}
                  aria-expanded={isStudentToolsGroupExpanded}
                  aria-controls="student-tools"
                  onKeyDown={(e) =>
                    onEnterKeyPressHandler(e, () =>
                      this.togglePanel(
                        'isStudentToolsGroupExpanded',
                        !isStudentToolsGroupExpanded
                      )
                    )
                  }
                >
                  <Icon type={isStudentToolsGroupExpanded ? 'minus' : 'plus'} />
                </span>
              </SettingsCategoryBlock>
              {isStudentToolsGroupExpanded && (
                <>
                  <Block id="show-calculator" smallSize={isSmallSize}>
                    <SettingContainer>
                      <Title>
                        Show Calculator{' '}
                        <DollarPremiumSymbol
                          premium={assessmentSuperPowersShowCalculator}
                        />
                      </Title>
                      <Body smallSize={isSmallSize}>
                        <Row>
                          <Col span={24}>
                            <CalculatorSettingsDescription width="100%" />
                          </Col>
                          <Col xs={24} sm={8}>
                            <CalculatorSettings
                              showDescription={false}
                              disabled={
                                disabled || !assessmentSuperPowersShowCalculator
                              }
                              isCheckBoxGroup
                              value={calcTypes}
                              onChange={this.updateFeatures('calcTypes')}
                            />
                          </Col>
                          <Col xs={24} sm={16}>
                            <Description style={{ marginTop: '4rem' }}>
                              {i18translate('calculatorTypesSettings.info')}
                            </Description>
                          </Col>
                        </Row>
                      </Body>
                    </SettingContainer>
                  </Block>

                  {!isDocBased && (
                    <Block id="show-rubric-to-students" smallSize={isSmallSize}>
                      <SettingContainer>
                        <Title>
                          <span>Show Rubric to Students </span>
                          <DollarPremiumSymbol premium={premium} />
                          <Tooltip
                            role="tooltip"
                            id="show-rubric-setting-tooltip"
                            trigger={['hover', 'focus']}
                            title={i18translate('showRubricToStudents.info')}
                          >
                            <IconInfo
                              color={lightGrey9}
                              style={{ marginLeft: '10px', cursor: 'pointer' }}
                              tabIndex={0}
                              aria-label="Show rubric to students setting info Tooltip"
                              aria-describedby="show-rubric-setting-tooltip"
                            />
                          </Tooltip>
                          <EduSwitchStyled
                            disabled={
                              !isShowRubricToStudentsSettingVisible ||
                              !owner ||
                              !isEditable ||
                              !premium
                            }
                            checked={showRubricToStudents}
                            data-cy="show-rubric-to-students-switch"
                            onChange={this.updateTestData(
                              'showRubricToStudents'
                            )}
                            aria-label={`Show Rubric To Students ${
                              showRubricToStudents ? 'enabled' : 'disabled'
                            }`}
                          />
                        </Title>
                        <Body smallSize={isSmallSize}>
                          <Description
                            style={{ marginTop: '10px' }}
                            data-cy="show-rubric-to-students-desc"
                          >
                            {i18translate('showRubricToStudents.info')}
                          </Description>
                        </Body>
                      </SettingContainer>
                    </Block>
                  )}
                  <EduIf
                    condition={[
                      !isDocBased,
                      isShowAutoEssayEvaluationSetting,
                      isAiEvaulationDistrict,
                    ].every((o) => !!o)}
                  >
                    <Block id="auto-essay-evaluation" smallSize={isSmallSize}>
                      <SettingContainer>
                        <Title>
                          <FlexContainer>
                            {i18translate('allowAutoEssayEvaluation.title')}
                            <BetaTag2>BETA</BetaTag2>
                            <DollarPremiumSymbol premium={premium} />
                          </FlexContainer>
                          <Tooltip
                            title={i18translate(
                              'allowAutoEssayEvaluation.info'
                            )}
                            role="tooltip"
                            id="allow-auto-essay-eval-setting-tooltip"
                            trigger={['hover', 'focus']}
                          >
                            <IconInfo
                              color={lightGrey9}
                              style={{ marginLeft: '10px', cursor: 'pointer' }}
                              tabIndex={0}
                              aria-label="Show auto evaluation setting info Tooltip"
                              aria-describedby="allow-auto-essay-eval-setting-tooltip"
                            />
                          </Tooltip>
                          <EduSwitchStyled
                            disabled={disabled || !premium}
                            checked={allowAutoEssayEvaluation}
                            data-cy="auto-essay-evaluation"
                            onChange={this.updateTestData(
                              'allowAutoEssayEvaluation'
                            )}
                          />
                        </Title>
                        <Body smallSize={isSmallSize}>
                          <Description
                            style={{ marginTop: '10px' }}
                            data-cy="auto-essay-evaluation-switch"
                          >
                            {i18translate('allowAutoEssayEvaluation.info')}
                            <span style={{ fontStyle: 'italic' }}>
                              {' '}
                              ({i18translate('rubric.infoText')})
                            </span>
                          </Description>
                        </Body>
                      </SettingContainer>
                    </Block>
                  </EduIf>
                  <HintsToStudents
                    premium={premium}
                    isSmallSize={isSmallSize}
                    disabled={disabled}
                    isDocBased={isDocBased}
                    isTestlet={isTestlet}
                    penaltyOnUsingHints={penaltyOnUsingHints}
                    showHintsToStudents={showHintsToStudents}
                    updateTestData={this.updateTestData}
                    showHintsFeatureAllowed={features.showHintsToStudents}
                    togglePenaltyOnUsingHints={togglePenaltyOnUsingHints}
                  />

                  <EduIf condition={showRefMaterial}>
                    <Block id="reference-material" smallSize={isSmallSize}>
                      <ReferenceMaterial
                        owner={owner}
                        isEditable={isEditable}
                        isSmallSize={isSmallSize}
                        premium={premium}
                        disabled={disabled}
                        setData={this.handleUpdateRefMaterial}
                        referenceDocAttributes={referenceDocAttributes}
                      />
                    </Block>
                  </EduIf>
                  {!isVideoQuiz && (
                    <Block id="accessibility" smallSize={isSmallSize}>
                      <Title>
                        Accessibility <DollarPremiumSymbol premium={premium} />
                      </Title>
                      <RadioWrapper
                        disabled={disabled}
                        style={{
                          marginTop: '20px',
                          marginBottom: 0,
                          flexDirection: 'row',
                        }}
                      >
                        {accessibilityData
                          .filter(
                            (item) =>
                              !(
                                (item.key === 'enableSkipAlert' ||
                                  item.key === 'enableUploadWork') &&
                                isDocBased
                              )
                          )
                          .map((o) => (
                            <StyledRow key={o.key}>
                              <Col xs={24} sm={6}>
                                <span
                                  style={{
                                    fontSize: 13,
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                  }}
                                >
                                  {accessibilities[o.key]}
                                </span>
                              </Col>
                              <Col xs={24} sm={18}>
                                <StyledRadioGroup
                                  disabled={disabled || !features[o.key]}
                                  onChange={(e) =>
                                    this.updateTestData(o.key)(e.target.value)
                                  }
                                  value={o.value}
                                  style={{
                                    flexDirection: 'row',
                                  }}
                                >
                                  <StyledRadioGroupItemRow>
                                    <Col xs={24} sm={12}>
                                      <RadioBtn
                                        data-cy={`${o.key}-enable`}
                                        value
                                      >
                                        ENABLE
                                      </RadioBtn>
                                    </Col>
                                    <Col xs={24} sm={12}>
                                      <RadioBtn
                                        data-cy={`${o.key}-disable`}
                                        value={false}
                                      >
                                        DISABLE
                                      </RadioBtn>
                                    </Col>
                                  </StyledRadioGroupItemRow>
                                </StyledRadioGroup>
                              </Col>
                              <Col span={24}>
                                <Description>{o.description}</Description>
                              </Col>
                            </StyledRow>
                          ))}
                      </RadioWrapper>
                      <RadioWrapper
                        disabled={disabled}
                        style={{
                          marginTop: '5px',
                          marginBottom: 0,
                          flexDirection: 'row',
                        }}
                      >
                        <StyledRow align="middle">
                          <Col span={6}>
                            <span
                              style={{
                                fontSize: 13,
                                fontWeight: 600,
                                textTransform: 'uppercase',
                              }}
                            >
                              Keypad <DollarPremiumSymbol premium={premium} />
                            </span>
                          </Col>
                          <Col xs={24} sm={12}>
                            <KeypadDropdown
                              value={this.keypadDropdownValue}
                              // This anonymous function should be wrapping the keypad selection function to make the Dropdown method work. Issue: EV-29904
                              onChangeHandler={(value) => {
                                this.keypadSelection(value)
                              }}
                              disabled={disabled || !premium}
                            />
                          </Col>
                          <Col span={24}>
                            <ConfirmationModal
                              centered
                              visible={warningKeypadSelection}
                              footer={[
                                <EduButton
                                  isGhost
                                  onClick={() =>
                                    this.confirmKeypadSelection(false)
                                  }
                                >
                                  CANCEL
                                </EduButton>,
                                <EduButton
                                  onClick={() =>
                                    this.confirmKeypadSelection(true)
                                  }
                                >
                                  PROCEED
                                </EduButton>,
                              ]}
                              textAlign="center"
                              onCancel={() =>
                                this.confirmKeypadSelection(false)
                              }
                            >
                              <p>
                                <b>{i18translate('keypadSettings.warning')}</b>
                              </p>
                            </ConfirmationModal>
                            <Description>
                              Select keypad to apply current selection to all
                              questions in the test
                            </Description>
                          </Col>
                        </StyledRow>
                      </RadioWrapper>
                    </Block>
                  )}
                </>
              )}
              <EduIf
                condition={
                  !isDocBased &&
                  !isVideoQuiz &&
                  accommodationSettingsData.filter((a) => a.isEnabled).length
                }
              >
                <SettingsCategoryBlock id="accommodations">
                  <h2>
                    Accommodations <DollarPremiumSymbol premium={premium} />
                  </h2>
                  <span
                    onClick={() =>
                      this.togglePanel(
                        'isAccommodationsExpanded',
                        !isAccommodationsExpanded
                      )
                    }
                    tabIndex={0}
                    role="button"
                    aria-label={`${
                      isAccommodationsExpanded ? 'Collapse' : 'Expand'
                    } accomodations group.`}
                    aria-expanded={isAccommodationsExpanded}
                    aria-controls="accommodations"
                    onKeyDown={(e) =>
                      onEnterKeyPressHandler(e, () =>
                        this.togglePanel(
                          'isAccommodationsExpanded',
                          !isAccommodationsExpanded
                        )
                      )
                    }
                  >
                    <Icon type={isAccommodationsExpanded ? 'minus' : 'plus'} />
                  </span>
                </SettingsCategoryBlock>
                {isAccommodationsExpanded && (
                  <Block id="accessibility" smallSize={isSmallSize}>
                    <AccommodationDescription i18translate={i18translate} />
                    <Accommodations
                      disabled={disabled}
                      updateTestData={this.updateTestData}
                      premium={premium}
                      accommodationsData={accommodationsData}
                      i18translate={i18translate}
                    />
                  </Block>
                )}
              </EduIf>
              <SettingsCategoryBlock id="anti-cheating">
                <h2>
                  Anti-Cheating <DollarPremiumSymbol premium={premium} />
                </h2>
                <span
                  onClick={() =>
                    this.togglePanel(
                      'isAntiCheatingGroupExpanded',
                      !isAntiCheatingGroupExpanded
                    )
                  }
                  tabIndex={0}
                  role="button"
                  aria-label={`${
                    isAntiCheatingGroupExpanded ? 'Collapse' : 'Expand'
                  } anti cheating group.`}
                  aria-expanded={isAntiCheatingGroupExpanded}
                  aria-controls="anti-cheating"
                  onKeyDown={(e) =>
                    onEnterKeyPressHandler(e, () =>
                      this.togglePanel(
                        'isAntiCheatingGroupExpanded',
                        !isAntiCheatingGroupExpanded
                      )
                    )
                  }
                >
                  <Icon type={isAntiCheatingGroupExpanded ? 'minus' : 'plus'} />
                </span>
              </SettingsCategoryBlock>
              {isAntiCheatingGroupExpanded && (
                <>
                  {!isDocBased && (
                    <Block id="suffle-question" smallSize={isSmallSize}>
                      <SettingContainer>
                        <Title>
                          <span>
                            Shuffle Items{' '}
                            <DollarPremiumSymbol
                              premium={assessmentSuperPowersShuffleQuestions}
                            />
                          </span>
                          <EduSwitchStyled
                            disabled={
                              disabled || !assessmentSuperPowersShuffleQuestions
                            }
                            checked={shuffleQuestions}
                            data-cy="shuffleQuestions"
                            onChange={this.updateTestData('shuffleQuestions')}
                          />
                        </Title>
                        <Body smallSize={isSmallSize}>
                          <Description>
                            {'If '}
                            <BlueText>ON</BlueText>, then order of questions
                            will be different for each student.
                          </Description>
                        </Body>
                      </SettingContainer>
                    </Block>
                  )}

                  {!isDocBased && (
                    <Block id="show-answer-choice" smallSize={isSmallSize}>
                      <SettingContainer>
                        <Title>
                          <span>
                            Shuffle Answer Choice{' '}
                            <DollarPremiumSymbol
                              premium={assessmentSuperPowersShuffleAnswerChoice}
                            />
                          </span>
                          <EduSwitchStyled
                            disabled={
                              disabled ||
                              !assessmentSuperPowersShuffleAnswerChoice
                            }
                            checked={shuffleAnswers}
                            data-cy="shuffleChoices"
                            onChange={this.updateTestData('shuffleAnswers')}
                          />
                        </Title>
                        <Body smallSize={isSmallSize}>
                          <Description>
                            {'If set to '}
                            <BlueText>ON</BlueText>, answer choices for multiple
                            choice and multiple select questions will be
                            randomly shuffled for students.
                          </Description>
                        </Body>
                      </SettingContainer>
                    </Block>
                  )}

                  <Block id="require-password" smallSize={isSmallSize}>
                    <SettingContainer>
                      <Row>
                        <Title>
                          Test Password{' '}
                          <DollarPremiumSymbol
                            premium={assessmentSuperPowersRequirePassword}
                          />
                        </Title>
                        <Body smallSize={isSmallSize}>
                          <Row gutter={24}>
                            <Col xs={24} sm={12}>
                              <SelectInputStyled
                                value={passwordPolicy}
                                data-cy={passwordPolicy}
                                disabled={
                                  disabled ||
                                  !assessmentSuperPowersRequirePassword
                                }
                                onChange={this.updateTestData('passwordPolicy')}
                                getPopupContainer={(trigger) =>
                                  trigger.parentNode
                                }
                              >
                                {Object.keys(passwordPolicyOptions).map(
                                  (key) => (
                                    <Option
                                      key={key}
                                      value={passwordPolicyValues[key]}
                                    >
                                      {passwordPolicyOptions[key]}
                                    </Option>
                                  )
                                )}
                              </SelectInputStyled>
                            </Col>
                            <Col xs={24} sm={12}>
                              {passwordPolicy ===
                              passwordPolicyValues.REQUIRED_PASSWORD_POLICY_STATIC ? (
                                <Description marginTop="0px">
                                  <TextInputStyled
                                    required
                                    color={isPasswordValid()}
                                    disabled={
                                      disabled ||
                                      !assessmentSuperPowersRequirePassword
                                    }
                                    onBlur={this.handleBlur}
                                    onChange={(e) =>
                                      this.updateTestData('assignmentPassword')(
                                        e.target.value
                                      )
                                    }
                                    size="large"
                                    value={assignmentPassword}
                                    type="text"
                                    placeholder="Enter Password"
                                    data-cy="passwordTextBox"
                                  />
                                  {validationMessage ? (
                                    <MessageSpan>
                                      {validationMessage}
                                    </MessageSpan>
                                  ) : (
                                    ''
                                  )}
                                </Description>
                              ) : passwordPolicy ===
                                passwordPolicyValues.REQUIRED_PASSWORD_POLICY_DYNAMIC ? (
                                <Description marginTop="0px">
                                  <TextInputStyled
                                    required
                                    type="number"
                                    data-cy="dynamicPasswordExpiryInput"
                                    disabled={
                                      disabled ||
                                      !assessmentSuperPowersRequirePassword
                                    }
                                    onChange={this.handleUpdatePasswordExpireIn}
                                    value={passwordExpireIn / 60}
                                    style={{
                                      width: '100px',
                                      marginRight: '10px',
                                    }}
                                    max={999}
                                    min={1}
                                    step={1}
                                  />{' '}
                                  Minutes
                                </Description>
                              ) : (
                                ''
                              )}
                            </Col>
                            {passwordPolicy ===
                              passwordPolicyValues.REQUIRED_PASSWORD_POLICY_DYNAMIC && (
                              <DynamicPasswordScopeInput
                                visibilityFormat={
                                  dynamicPasswordScopeInputFormat.SINGLE_ROW
                                }
                                onChange={(e) =>
                                  this.updateTestData('dynamicPasswordScope')(
                                    e.target.value
                                  )
                                }
                                value={dynamicPasswordScope}
                                preventOverride={editEnable || freezeSettings}
                              />
                            )}
                            <Col span={24} style={{ marginTop: '10px' }}>
                              {passwordPolicy ===
                              passwordPolicyValues.REQUIRED_PASSWORD_POLICY_STATIC ? (
                                <Description>
                                  The password is entered by you and does not
                                  change. Students must enter this password
                                  before they can take the assessment.
                                </Description>
                              ) : passwordPolicy ===
                                passwordPolicyValues.REQUIRED_PASSWORD_POLICY_DYNAMIC ? (
                                <>
                                  {isRegradeFlow &&
                                    roleuser.DA_SA_ROLE_ARRAY.includes(
                                      userRole
                                    ) && (
                                      <Description style={{ color: '#E0004B' }}>
                                        <IconWarnCircle
                                          color="#E0004B"
                                          style={{
                                            width: '1rem',
                                            marginBottom: '-0.25rem',
                                            marginRight: '0.25rem',
                                          }}
                                        />
                                        Changing the password scope will affect
                                        all current-year assignments for this
                                        test. It will apply to all classes where
                                        the assignment is not marked as done.
                                      </Description>
                                    )}
                                  <Description>
                                    {roleuser.DA_SA_ROLE_ARRAY.includes(
                                      userRole
                                    )
                                      ? i18translate(
                                          'dynamicPasswordInfoMessage.admin'
                                        )
                                      : i18translate(
                                          'dynamicPasswordInfoMessage.teacher'
                                        )}
                                  </Description>
                                </>
                              ) : (
                                <Description>
                                  Require your students to type a password when
                                  opening the assessment.
                                </Description>
                              )}
                            </Col>
                          </Row>
                        </Body>
                      </Row>
                    </SettingContainer>
                  </Block>

                  <Block id="block-save-and-continue" smallSize={isSmallSize}>
                    <Title>
                      <span>
                        Complete Test in One Sitting
                        <DollarPremiumSymbol premium={premium} />
                      </span>
                      <EduSwitchStyled
                        disabled={disabled || !premium}
                        checked={blockSaveAndContinue}
                        data-cy="bockSaveAndContinueSwitch"
                        onChange={(v) =>
                          this.updateTestData('blockSaveAndContinue')(v)
                        }
                      />
                    </Title>
                    <Body smallSize={isSmallSize}>
                      <Description>
                        If <b>ON</b>, then students will not be allowed to exit
                        the test without submitting. In case they close the app
                        they will be paused and the instructor will need to
                        manually resume.
                      </Description>
                    </Body>
                  </Block>

                  <Block id="restrict-back-navigation" smallSize={isSmallSize}>
                    <SettingContainer>
                      <Title>
                        <span>
                          Restrict Question Navigation{' '}
                          <DollarPremiumSymbol
                            premium={
                              assessmentSuperPowersRestrictQuestionBackNav
                            }
                          />
                        </span>
                        <EduSwitchStyled
                          disabled={
                            disabled ||
                            !assessmentSuperPowersRestrictQuestionBackNav ||
                            isDocBased
                          }
                          checked={blockNavigationToAnsweredQuestions}
                          data-cy="restrict-back-nav-switch-test"
                          onChange={this.updateTestData(
                            'blockNavigationToAnsweredQuestions'
                          )}
                        />
                      </Title>
                      <Body smallSize={isSmallSize}>
                        <Description>
                          {'If '}
                          <BlueText>ON</BlueText>, then students will be
                          restricted from navigating back to the previous
                          question. Recommended to use along with Shuffle
                          Questions for preventing cheating among students.
                          (This setting is not applicable for SnapQuiz and
                          VideoQuiz)
                        </Description>
                      </Body>
                    </SettingContainer>
                  </Block>

                  <Block
                    id="require-safe-exame-browser"
                    smallSize={isSmallSize}
                  >
                    <SettingContainer>
                      <Title>
                        <span>
                          {safeModeI18nTranslation(i18translate, 'title')}
                          <DollarPremiumSymbol
                            premium={
                              assessmentSuperPowersRequireSafeExamBrowser
                            }
                          />
                        </span>
                        <Tooltip
                          title={safeModeI18nTranslation(i18translate, 'info')}
                          role="tooltip"
                          id="seb-setting-tooltip"
                          trigger={['hover', 'focus']}
                        >
                          <IconInfo
                            color={lightGrey9}
                            style={{ cursor: 'pointer', marginLeft: '10px' }}
                            tabIndex={0}
                            aria-label="Safe Exam browser setting info Tooltip"
                            aria-describedby="seb-setting-tooltip"
                          />
                        </Tooltip>
                        <EduSwitchStyled
                          disabled={
                            disabled ||
                            !assessmentSuperPowersRequireSafeExamBrowser
                          }
                          checked={safeBrowser}
                          onChange={this.updateTestData('safeBrowser')}
                        />
                      </Title>
                      <Body smallSize={isSmallSize}>
                        <Row>
                          <Col span={24}>
                            {safeBrowser && (
                              <>
                                <TextInputStyled
                                  className={`sebPassword ${
                                    sebPassword && sebPassword.length
                                      ? ' good'
                                      : ' dirty'
                                  }`}
                                  disabled={
                                    disabled ||
                                    !assessmentSuperPowersRequireSafeExamBrowser
                                  }
                                  ref={sebPasswordRef}
                                  prefix={
                                    <i
                                      className={`fa fa-eye${
                                        showPassword ? '-slash' : ''
                                      }`}
                                      onClick={this.handleShowPassword}
                                    />
                                  }
                                  onChange={this.setPassword}
                                  size="large"
                                  value={sebPassword || ''}
                                  type={showPassword ? 'text' : 'password'}
                                  placeholder="Quit Password"
                                />

                                <MessageSpan>
                                  {sebPasswordErrorMessage}
                                </MessageSpan>
                              </>
                            )}
                          </Col>
                        </Row>
                        <Description>
                          {safeModeI18nTranslation(i18translate, 'info')}
                        </Description>
                      </Body>
                    </SettingContainer>
                  </Block>

                  <Block id="restrict-navigation-out" smallSize={isSmallSize}>
                    <Title>
                      Restrict Navigation Out of Test{' '}
                      <DollarPremiumSymbol premium={premium} />
                    </Title>
                    <Body smallSize={isSmallSize}>
                      <Row>
                        <Col xs={24} sm={11}>
                          <StyledRadioGroup
                            disabled={disabled || !premium || safeBrowser}
                            onChange={(_restrictNavigationOut) => {
                              const { value } = _restrictNavigationOut.target
                              this.updateFeatures('restrictNavigationOut')(
                                value
                              )
                              if (value === 'warn-and-report' || !value) {
                                this.updateFeatures(
                                  'restrictNavigationOutAttemptsThreshold'
                                )(0)
                              } else {
                                this.updateFeatures(
                                  'restrictNavigationOutAttemptsThreshold'
                                )(5)
                              }
                            }}
                            value={restrictNavigationOut || undefined}
                          >
                            <StyledRadioGroupItemRow>
                              <Col xs={24} sm={12}>
                                <RadioBtn
                                  value={undefined}
                                  key="disabled"
                                  data-cy="restrict-nav-out-disabled"
                                >
                                  DISABLED
                                </RadioBtn>
                              </Col>
                              <Col xs={24} sm={12}>
                                <RadioBtn
                                  value="warn-and-report"
                                  key="warn-and-report"
                                  data-cy="restrict-nav-out-warn-report"
                                >
                                  WARN AND REPORT ONLY
                                </RadioBtn>
                              </Col>
                              <Col xs={24} sm={12}>
                                <RadioBtn
                                  value="warn-and-report-after-n-alerts"
                                  key="warn-and-report-after-n-alerts"
                                  data-cy="restrict-nav-out-warn-report-alerts"
                                >
                                  WARN AND BLOCK TEST AFTER{' '}
                                  <InputNumberStyled
                                    size="small"
                                    value={
                                      restrictNavigationOut ===
                                      'warn-and-report-after-n-alerts'
                                        ? restrictNavigationOutAttemptsThreshold
                                        : undefined
                                    }
                                    min={1}
                                    onChange={this.updateFeatures(
                                      'restrictNavigationOutAttemptsThreshold'
                                    )}
                                    disabled={
                                      !(
                                        restrictNavigationOut ===
                                        'warn-and-report-after-n-alerts'
                                      ) ||
                                      disabled ||
                                      safeBrowser
                                    }
                                  />{' '}
                                  ALERTS
                                  {navigationThresholdMoreThan1 ? (
                                    <>
                                      {' '}
                                      <br />{' '}
                                      <span
                                        style={{ textTransform: 'lowercase' }}
                                      >
                                        {`or maximum of ${
                                          restrictNavigationOutAttemptsThreshold *
                                          5
                                        } sec.`}
                                      </span>{' '}
                                    </>
                                  ) : (
                                    ''
                                  )}
                                </RadioBtn>
                              </Col>
                            </StyledRadioGroupItemRow>
                          </StyledRadioGroup>
                        </Col>
                        <Col xs={24} sm={13}>
                          <Description>
                            If <b>ON</b>, then students must take the test in
                            full screen mode to prevent opening another browser
                            window. Alert will appear if student has navigated
                            away for more than 5 seconds. If the designated
                            number of alerts are exceeded, the student’s
                            assignment will be paused and the instructor will
                            need to manually reset.
                            <br />
                            Please Note: this is not compatible with iPads.
                            {navigationThresholdMoreThan1 ? (
                              <>
                                <br />
                                <br />
                                Alert will appear if student has navigated away
                                for more than 5 seconds and student will be
                                blocked after{' '}
                                {restrictNavigationOutAttemptsThreshold *
                                  5}{' '}
                                seconds{' '}
                              </>
                            ) : (
                              ''
                            )}
                          </Description>
                        </Col>
                      </Row>
                    </Body>
                  </Block>
                </>
              )}
              {/* Displaying the section settings header and component. */}
              {hasSections && (
                <SettingsCategoryBlock
                  id="section-settings"
                  data-cy="sectionSettings"
                >
                  <h2>
                    Sections <DollarPremiumSymbol premium={premium} />
                  </h2>
                  <span
                    onClick={() =>
                      this.togglePanel(
                        'isSectionsGroupExpanded',
                        !isSectionsGroupExpanded
                      )
                    }
                    tabIndex={0}
                    role="button"
                    aria-label={`${
                      isSectionsGroupExpanded ? 'Collapse' : 'Expand'
                    } section settings group.`}
                    aria-expanded={isSectionsGroupExpanded}
                    aria-controls="section-settings"
                    onKeyDown={(e) =>
                      onEnterKeyPressHandler(e, () =>
                        this.togglePanel(
                          'isSectionsGroupExpanded',
                          !isSectionsGroupExpanded
                        )
                      )
                    }
                  >
                    <Icon type={isSectionsGroupExpanded ? 'minus' : 'plus'} />
                  </span>
                </SettingsCategoryBlock>
              )}
              {hasSections && isSectionsGroupExpanded && (
                <ShowSectionSettings
                  itemGroups={itemGroups}
                  premium={premium}
                  disabled={disabled}
                  isSmallSize={isSmallSize}
                  preventSectionNavigation={preventSectionNavigation}
                  updateSectionCalc={this.updateSectionCalc}
                  updateTestData={this.updateTestData}
                  isSectionAdaptiveTest={isSectionAdaptiveTest}
                  isNormalSectionsTest={isNormalSectionsTest}
                  lockSections={lockSections}
                />
              )}
              <SettingsCategoryBlock id="performance-band">
                <h2>
                  Performance Band <DollarPremiumSymbol premium={premium} />
                </h2>
                <span
                  onClick={() =>
                    this.togglePanel(
                      'isMiscellaneousGroupExpanded',
                      !isMiscellaneousGroupExpanded
                    )
                  }
                  tabIndex={0}
                  role="button"
                  aria-label={`${
                    isMiscellaneousGroupExpanded ? 'Collapse' : 'Expand'
                  } miscellaneous group.`}
                  aria-expanded={isMiscellaneousGroupExpanded}
                  aria-controls="miscellaneous"
                  onKeyDown={(e) =>
                    onEnterKeyPressHandler(e, () =>
                      this.togglePanel(
                        'isMiscellaneousGroupExpanded',
                        !isMiscellaneousGroupExpanded
                      )
                    )
                  }
                >
                  <Icon
                    type={isMiscellaneousGroupExpanded ? 'minus' : 'plus'}
                  />
                </span>
              </SettingsCategoryBlock>
              {isMiscellaneousGroupExpanded && (
                <>
                  <Block id="performance-bands" smallSize={isSmallSize}>
                    <PerformanceBand
                      setSettingsData={(val) =>
                        this.updateTestData('performanceBand')(val)
                      }
                      performanceBand={performanceBand || {}}
                      disabled={disabled || !performanceBands}
                      isFeatureAvailable={performanceBands}
                    />
                    <Description>
                      Performance bands are set by district or school admins.
                      Teachers can choose from the different profiles created by
                      the admin.
                    </Description>
                  </Block>

                  <Block id="standards-proficiency" smallSize={isSmallSize}>
                    <StandardProficiencyTable
                      standardGradingScale={standardGradingScale || {}}
                      setSettingsData={(val) =>
                        this.updateTestData('standardGradingScale')(val)
                      }
                      disabled={disabled || !premium}
                      isFeatureAvailable={premium}
                    />
                    <Description>
                      Standards based scales are set by district or school
                      admins. Teachers can choose from the different profiles
                      created by the admin
                    </Description>
                  </Block>

                  {playerSkinType ===
                    playerSkinValues.testlet.toLowerCase() && (
                    <Block id="external-metadata" smallSize={isSmallSize}>
                      <Title>External Metadata</Title>
                      <Row gutter={16} style={{ marginTop: 20 }}>
                        <Col span={12}>
                          <FieldLabel>EMBED URL</FieldLabel>
                          <TextInputStyled
                            size="large"
                            type="text"
                            onChange={this.updateExternalData('testletURL')}
                            value={testletConfig?.testletURL || ''}
                          />
                        </Col>
                        <Col span={12}>
                          <FieldLabel>EMBED ID</FieldLabel>
                          <TextInputStyled
                            size="large"
                            type="text"
                            onChange={this.updateExternalData('testletId')}
                            value={testletConfig?.testletId || ''}
                          />
                        </Col>
                      </Row>
                    </Block>
                  )}
                </>
              )}
            </Col>
          </Row>
        </Container>
      </MainContentWrapper>
    )
  }
}

Setting.propTypes = {
  history: PropTypes.object.isRequired,
  windowWidth: PropTypes.number.isRequired,
  setMaxAttempts: PropTypes.func.isRequired,
  setTestData: PropTypes.func.isRequired,
  owner: PropTypes.bool,
  entity: PropTypes.object.isRequired,
  isEditable: PropTypes.bool,
  userRole: PropTypes.string,
}

Setting.defaultProps = {
  owner: false,
  userRole: '',
  isEditable: false,
}

const enhance = compose(
  memo,
  withRouter,
  withWindowSizes,
  withNamespaces('author'),
  connect(
    (state) => ({
      entity: getTestEntitySelector(state),
      features: getUserFeatures(state),
      userRole: getUserRole(state),
      isDynamicTest: isDynamicTestSelector(state),
      defaultTestTypeProfiles: defaultTestTypeProfilesSelector(state),
      standardsData: get(state, ['standardsProficiencyReducer', 'data'], []),
      performanceBandsData: get(
        state,
        ['performanceBandReducer', 'profiles'],
        []
      ),
      isReleaseScorePremium: getReleaseScorePremiumSelector(state),
      disableAnswerOnPaper: getDisableAnswerOnPaperSelector(state),
      premium: state?.user?.user?.features?.premium,
      allowReferenceMaterial: allowReferenceMaterialSelector(state),
      totalItems: state?.tests?.entity?.isDocBased
        ? state?.tests?.entity?.summary?.totalQuestions
        : state?.tests?.entity?.summary?.totalItems,
      editEnable: state.tests?.editEnable,
      allowedToSelectMultiLanguage: allowedToSelectMultiLanguageInTest(state),
      testAssignments: getAssignmentsSelector(state),
      isEtsDistrict: isEtsDistrictSelector(state),
      testSettingsList: getTestSettingsListSelector(state),
      testDefaultSettings: getTestDefaultSettingsSelector(state),
      userId: getUserId(state),
      isAiEvaulationDistrict: getIsAiEvaulationDistrictSelector(state),
      canSchoolAdminUseDistrictCommon: canSchoolAdminUseDistrictCommonSelector(
        state
      ),
      canTeacherAuthorCommonTests: canTeacherAuthorCommonTestsSelector(state),
      hasSections: hasSectionsSelector(state),
      userPermissions: getUserPermissions(state),
      districtId: getUserOrgId(state),
      districtTestSettings: getTestSettings(state),
      isSurveyTest: isSurveyTestSelector(state),
      isNormalSectionsTest: isNormalSectionsTestSelector(state),
      isUserDistrictSuperAdmin: isUserDistrictSuperAdminSelector(state),
      subscription: getSubscriptionSelector(state),
      userTestTypesInternal: getUserTestTypes(state),
      allTestTypesInternal: getTestTypesFormatedConstant(state),
      viewedTutorials: viewedTutorialsSelector(state),
      districtState: getCurrentSchoolState(state),
    }),
    {
      setMaxAttempts: setMaxAttemptsAction,
      setSafePassword: setSafeBrowserPassword,
      setTestData: setTestDataAction,
      resetUpdatedState: resetUpdatedStateAction,
      saveTestSettings: saveTestSettingsAction,
      deleteTestSettingRequest: deleteTestSettingRequestAction,
      updateTestSettingRequest: updateTestSettingRequestAction,
      togglePenaltyOnUsingHints: togglePenaltyOnUsingHintsAction,
      loadDistrictTestSetting: receiveTestSettingAction,
      setViewedTutorials: setViewedTutorialsAction,
    }
  )
)

export default enhance(Setting)

const InputNumberStyled = Styled(InputNumber)`
    width: 60px;
`

const StyledSpan = Styled.span`
  &.spanText {
    font-weight: ${(props) => props.theme.semiBold};
    font-size: 12px;
  }
`
